<template>
  <div class="index-root">
    <canvas class="particle-canvas" ref="particleCanvas"></canvas>

    <transition name="lb-fade">
      <div v-if="lightbox.open" class="lightbox-ov" @click.self="closeLightbox">
        <div class="lightbox-box">
          <button class="lb-close" @click="closeLightbox">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
          <button class="lb-nav lb-prev" @click="lbPrev" v-if="lightbox.photos.length > 1">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="15 18 9 12 15 6"/>
            </svg>
          </button>
          <button class="lb-nav lb-next" @click="lbNext" v-if="lightbox.photos.length > 1">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </button>
          <div class="lb-main">
            <transition name="lb-img" mode="out-in">
              <img :key="lightbox.idx" :src="lightbox.photos[lightbox.idx]" :alt="lightbox.title" @error="imgErr"
                   class="lb-photo"/>
            </transition>
            <div class="lb-caption">
              <span class="lb-title">{{ lightbox.title }}</span>
              <span class="lb-counter" v-if="lightbox.photos.length > 1">{{
                  lightbox.idx + 1
                }} / {{ lightbox.photos.length }}</span>
            </div>
          </div>
          <div class="lb-thumbs" v-if="lightbox.photos.length > 1">
            <div v-for="(ph, i) in lightbox.photos" :key="i" class="lb-thumb" :class="{ active: lightbox.idx === i }"
                 @click="lightbox.idx = i">
              <img :src="ph" @error="imgErr"/>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <header class="site-header" :class="{ scrolled: scrolled }">
      <div class="header-inner">
        <router-link to="/" class="text_decaration">
          <div class="brand">
            <div class="brand-emblem"><img src="../assets/gerb.webp" width="42" alt="Gerb"/></div>
            <div class="brand-text">
              <span class="brand-sup">O‘zbekiston Respublikasi</span>
              <span class="brand-main">Madaniy Meros Agentligi</span>
            </div>
          </div>
        </router-link>
        <nav class="main-nav">
          <a class="nav-link active" href="#">Bosh sahifa</a>
          <a class="nav-link" href="#stats-section">Statistika</a>
          <a class="nav-link" href="#objects-section">Obyektlar</a>
          <a class="nav-link" href="#artifacts-section">Artefaktlar</a>
          <a class="nav-link" href="#museum-catalog-section">Muzey Katalogi</a>
          <a class="nav-link" href="#cultural-wealth-section">Madaniy Boyliklar</a>
          <router-link class="nav-link map-nav-link" to="/map">
            <span class="map-link-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path
                d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z"/><path d="M8 2v16M16 6v16"/></svg></span>
            Interaktiv Xarita <span class="new-badge">NEW</span>
          </router-link>
        </nav>
        <router-link to="/vr-tour" class="vr-btn">
          <span class="vr-btn-icon"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"><path
              d="M12 2a10 10 0 1 0 10 10A10 10 0 0 0 12 2z"/><path d="M2 12h20"/><path d="M12 2a15 15 0 0 1 0 20"/><path
              d="M12 2a15 15 0 0 0 0 20"/><circle cx="12" cy="12" r="2" fill="currentColor" stroke="none"/></svg></span>
          <span class="vr-btn-text"><span class="vr-btn-top">360°</span><span
              class="vr-btn-bottom">VR Tour</span></span>
          <span class="vr-pulse"></span>
        </router-link>
        <div class="gt-wrap" ref="gtWrap">
          <button class="gt-trigger" @click="toggleGT" :class="{ active: gtOpen }">
            <span class="gtl-flag-sm">{{ currentLang.flag }}</span>
            <span class="gt-label">{{ currentLang.name }}</span>
            <span class="gt-caret" :class="{ flipped: gtOpen }"><svg viewBox="0 0 24 24" fill="none"
                                                                     stroke="currentColor" stroke-width="2.2"><polyline
                points="6 9 12 15 18 9"/></svg></span>
          </button>
          <transition name="gt-drop">
            <div v-if="gtOpen" class="gt-panel">
              <div class="gt-panel-head">Tilni tanlang</div>
              <div class="gt-langs">
                <button v-for="lang in gtLangs" :key="lang.code" class="gt-lang-item"
                        :class="{ active: gtSelected === lang.code }" @click="selectGTLang(lang)">
                  <span class="gtl-flag">{{ lang.flag }}</span><span class="gtl-name">{{ lang.name }}</span><span
                    class="gtl-native">{{ lang.native }}</span>
                  <span class="gtl-check" v-if="gtSelected === lang.code"><svg viewBox="0 0 24 24" fill="none"
                                                                               stroke="currentColor" stroke-width="2.5"><polyline
                      points="20 6 9 17 4 12"/></svg></span>
                </button>
              </div>
              <div id="google_translate_element" class="gt-element-host"></div>
            </div>
          </transition>
        </div>
        <button class="mobile-menu-btn" @click="mobileMenu = !mobileMenu" :class="{ open: mobileMenu }">
          <span></span><span></span><span></span>
        </button>
      </div>
      <transition name="menu-drop">
        <div v-if="mobileMenu" class="mobile-nav">
          <a class="mnav-link" href="#" @click="mobileMenu=false">Bosh sahifa</a>
          <a class="mnav-link" href="#stats-section" @click="mobileMenu=false">Statistika</a>
          <a class="mnav-link" href="#objects-section" @click="mobileMenu=false">Obyektlar</a>
          <a class="mnav-link" href="#artifacts-section" @click="mobileMenu=false">Artefaktlar</a>
          <a class="mnav-link" href="#museum-catalog-section" @click="mobileMenu=false">Muzey Katalogi</a>
          <a class="mnav-link" href="#cultural-wealth-section" @click="mobileMenu=false">Madaniy Boyliklar</a>
          <router-link class="mnav-link mnav-map" to="/map" @click.native="mobileMenu=false">&#x1F5FA; Interaktiv
            Xarita
          </router-link>
          <router-link class="mnav-link mnav-vr" to="/vr-tour" @click.native="mobileMenu=false">🥽 360° VR Tour
          </router-link>
          <div class="mnav-translate">
            <div class="mnt-label">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                   style="width:13px;height:13px">
                <circle cx="12" cy="12" r="10"/>
                <path
                    d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
              </svg>
              Til tanlash
            </div>
            <div class="mnt-langs">
              <button v-for="lang in gtLangs" :key="'m-'+lang.code" class="mnt-btn"
                      :class="{ active: gtSelected === lang.code }" @click="selectGTLang(lang); mobileMenu=false">
                {{ lang.flag }} {{ lang.name }}
              </button>
            </div>
          </div>
        </div>
      </transition>
    </header>

    <section class="hero-section">
      <div class="hero-track" ref="heroTrack">
        <div v-for="(slide, idx) in heroSlides" :key="'slide-'+idx" class="hero-slide"
             :class="{ active: heroIdx === idx }">
          <div class="slide-bg"
               :style="slide.img ? { backgroundImage: 'url('+slide.img+')' } : { background: slide.gradient }"></div>
          <div class="slide-photo-btn" v-if="slide.img" @click="openSlideGallery(idx)">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
              <line x1="11" y1="8" x2="11" y2="14"/>
              <line x1="8" y1="11" x2="14" y2="11"/>
            </svg>
          </div>
          <div class="slide-overlay"></div>
          <div class="slide-noise"></div>
        </div>
        <div class="hero-grid-lines">
          <div class="hgl hgl-v1"></div>
          <div class="hgl hgl-v2"></div>
          <div class="hgl hgl-h1"></div>
        </div>
        <div class="hero-stage">
          <div class="hero-left">
            <transition name="slide-up" mode="out-in">
              <div class="hero-eyebrow" :key="'eyebrow-'+heroIdx"><span class="eyebrow-line"></span><span
                  class="eyebrow-text">{{ heroSlides[heroIdx].tag }}</span></div>
            </transition>
            <transition name="slide-up" mode="out-in">
              <h1 class="hero-title" :key="'title-'+heroIdx">
                <span class="ht-small">{{ heroSlides[heroIdx].titleSmall }}</span>
                <span class="ht-big">{{ heroSlides[heroIdx].titleBig }}</span>
              </h1>
            </transition>
            <transition name="slide-up" mode="out-in">
              <p class="hero-desc" :key="'desc-'+heroIdx">{{ heroSlides[heroIdx].desc }}</p>
            </transition>
            <div class="hero-actions">
              <router-link to="/map" class="btn-primary">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z"/>
                </svg>
                Xaritada Ko'rish
              </router-link>
              <a href="#objects-section" class="btn-ghost">Obyektlar Ro‘yxati
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </a>
            </div>
          </div>
          <div class="hero-right">
            <div class="slide-strip">
              <div v-for="(slide, idx) in heroSlides" :key="'strip-'+idx" class="strip-item"
                   :class="{ active: heroIdx === idx }" @click="goToSlide(idx)">
                <div class="strip-thumb" v-if="slide.img"><img :src="slide.img" :alt="slide.stripLabel"
                                                               @error="imgErr"/></div>
                <div class="strip-thumb strip-thumb-grad" v-else :style="{ background: slide.gradient }"></div>
                <div class="strip-info">
                  <div class="strip-num">{{ String(idx + 1).padStart(2, '0') }}</div>
                  <div class="strip-label">{{ slide.stripLabel }}</div>
                </div>
                <div class="strip-progress" v-if="heroIdx === idx">
                  <div class="strip-bar" :style="{ height: slideProgress + '%' }"></div>
                </div>
              </div>
            </div>
            <transition name="card-pop" mode="out-in">
              <div class="hero-card" :key="'card-'+heroIdx" v-if="featuredObjects[heroIdx % featuredObjects.length]"
                   @click="openObjGallery(featuredObjects[heroIdx % featuredObjects.length])" style="cursor:pointer">
                <div class="hc-image">
                  <img
                      v-if="featuredObjects[heroIdx % featuredObjects.length].photos && featuredObjects[heroIdx % featuredObjects.length].photos.length"
                      :src="featuredObjects[heroIdx % featuredObjects.length].photos[0]"
                      :alt="featuredObjects[heroIdx % featuredObjects.length].obj_name" @error="imgErr"/>
                  <div v-else class="hc-noimg"
                       :style="{ background: typeGradient(featuredObjects[heroIdx % featuredObjects.length].obj_type) }">
                    <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.3)" stroke-width="1">
                      <rect x="3" y="3" width="18" height="18" rx="2"/>
                      <circle cx="8.5" cy="8.5" r="1.5"/>
                      <polyline points="21 15 16 10 5 21"/>
                    </svg>
                  </div>
                  <div class="hc-zoom-hint">
                    <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                      <circle cx="11" cy="11" r="8"/>
                      <path d="m21 21-4.35-4.35"/>
                    </svg>
                  </div>
                </div>
                <div class="hc-body">
                  <span class="hc-badge"
                        :style="{ background: typeColor(featuredObjects[heroIdx % featuredObjects.length].obj_type) }">{{
                      shortType(featuredObjects[heroIdx % featuredObjects.length].obj_type)
                    }}</span>
                  <p class="hc-name">{{ featuredObjects[heroIdx % featuredObjects.length].obj_name }}</p>
                  <div class="hc-loc" v-if="featuredObjects[heroIdx % featuredObjects.length].region_name">
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                      <circle cx="12" cy="10" r="3"/>
                    </svg>
                    {{ featuredObjects[heroIdx % featuredObjects.length].region_name }}
                  </div>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <div class="hero-stats-bar">
          <div class="hsb-item" v-for="s in heroStatItems" :key="s.label"><span class="hsb-num">{{ s.val }}</span><span
              class="hsb-label">{{ s.label }}</span></div>
          <div class="hsb-sep"></div>
          <div class="slider-controls-inline">
            <button class="sc-btn" @click="slidePrev">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="15 18 9 12 15 6"/>
              </svg>
            </button>
            <span class="sc-count">{{
                String(heroIdx + 1).padStart(2, '0')
              }} / {{ String(heroSlides.length).padStart(2, '0') }}</span>
            <button class="sc-btn" @click="slideNext">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <polyline points="9 18 15 12 9 6"/>
              </svg>
            </button>
          </div>
        </div>
        <div class="hero-progress-line">
          <div class="hpl-fill" :style="{ width: slideProgress + '%' }"></div>
        </div>
      </div>
    </section>

    <section class="stats-section" id="stats-section">
      <div class="stats-inner">
        <div class="stat-card" v-for="s in statsData" :key="s.label">
          <div class="sc-icon" :style="{ background: s.bg }">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" v-html="s.icon"></svg>
          </div>
          <div class="sc-body">
            <div class="sc-num">{{ s.animated }}</div>
            <div class="sc-label">{{ s.label }}</div>
          </div>
          <div class="sc-bar" :style="{ background: s.bg, width: s.pct+'%' }"></div>
        </div>
      </div>
    </section>

    <section class="map-cta-section">
      <div class="mcs-inner">
        <div class="mcs-content">
          <div class="mcs-tag">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z"/>
            </svg>
            Interaktiv Xarita
          </div>
          <h2 class="mcs-title">Barcha yodgorliklarni <em>xaritada</em> ko‘ring</h2>
          <p class="mcs-desc">Real vaqt ma’lumotlari, AI tahlil, QR pasport va ko‘p qirrali filtrlash imkoniyatlari
            bilan to‘liq interaktiv xarita tizimi.</p>
          <ul class="mcs-features">
            <li><span class="feat-dot"></span>Klasterli marker ko‘rinishi</li>
            <li><span class="feat-dot"></span>Sun'iy intellekt bilan holat baholash</li>
            <li><span class="feat-dot"></span>Hudud va tur bo‘yicha filtrlash</li>
            <li><span class="feat-dot"></span>QR pasport yuklab olish</li>
            <li><span class="feat-dot"></span>Satellite va street ko‘rinishi</li>
          </ul>
          <router-link to="/map" class="btn-primary btn-large">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z"/>
              <path d="M8 2v16M16 6v16"/>
            </svg>
            Xaritani Ochish
          </router-link>
        </div>
        <div class="mcs-preview">
          <div class="map-mock">
            <div class="mm-topbar">
              <div class="mm-dot" style="background:#ef4444"></div>
              <div class="mm-dot" style="background:#f59e0b"></div>
              <div class="mm-dot" style="background:#22c55e"></div>
              <span>Interaktiv Xarita &mdash; madaniymeros.uz</span></div>
            <div class="mm-body">
              <div class="mm-bg"></div>
              <div class="mm-pin pin-a">
                <div class="mmp-dot" style="background:#1a472a"></div>
                <div class="mmp-pulse"></div>
              </div>
              <div class="mm-pin pin-b">
                <div class="mmp-dot" style="background:#c8813a"></div>
                <div class="mmp-pulse" style="border-color:rgba(200,129,58,.4)"></div>
              </div>
              <div class="mm-pin pin-c">
                <div class="mmp-dot" style="background:#7b5ea7"></div>
                <div class="mmp-pulse" style="border-color:rgba(123,94,167,.4)"></div>
              </div>
              <div class="mm-pin pin-d">
                <div class="mmp-dot" style="background:#2e86ab"></div>
                <div class="mmp-pulse" style="border-color:rgba(46,134,171,.4)"></div>
              </div>
              <div class="mm-cluster" style="top:30%;left:55%">47</div>
              <div class="mm-cluster small" style="top:60%;left:25%">12</div>
              <div class="mm-panel">
                <div class="mmp-row" v-for="(o,i) in featuredObjects.slice(0,3)" :key="i">
                  <div class="mmp-dot2" :style="{ background: typeColor(o.obj_type) }"></div>
                  <span>{{
                      o.obj_name ? o.obj_name.slice(0, 22) + (o.obj_name.length > 22 ? '…' : '') : 'Yuklanmoqda'
                    }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="objects-section" id="objects-section">
      <div class="sec-head">
        <div class="sh-left">
          <div class="sh-tag">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
            Madaniy Meros Obyektlari
          </div>
          <h2 class="sh-title">So‘nggi Qo‘shilganlar</h2>
        </div>
        <div class="sh-right">
          <div class="filter-tabs">
            <button v-for="t in typeFilter" :key="t.val" class="ftab" :class="{ active: activeType === t.val }"
                    @click="setType(t.val)" :style="activeType===t.val ? { borderColor: t.color, color: t.color } : {}">
              {{ t.label }}
            </button>
          </div>
        </div>
      </div>
      <div class="search-row">
        <div class="search-box">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.35-4.35"/>
          </svg>
          <input v-model="searchQ" @input="debounceSearch" type="text" placeholder="Obyekt nomi bo‘yicha qidirish..."/>
          <button v-if="searchQ" class="search-clear" @click="clearSearch">&#215;</button>
        </div>
        <div class="region-sel">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
            <circle cx="12" cy="10" r="3"/>
          </svg>
          <select v-model="selectedRegion" @change="onFilterChange">
            <option value="">Barcha hududlar</option>
            <option value="Qoraqalpogʻiston Respublikasi">Qoraqalpog'iston</option>
            <option value="Andijon viloyati">Andijon</option>
            <option value="Buxora viloyati">Buxoro</option>
            <option value="Fargʻona viloyati">Farg'ona</option>
            <option value="Jizzax viloyati">Jizzax</option>
            <option value="Namangan viloyati">Namangan</option>
            <option value="Qashqadaryo viloyati">Qashqadaryo</option>
            <option value="Navoiy viloyati">Navoiy</option>
            <option value="Samarqand viloyati">Samarqand</option>
            <option value="Sirdaryo viloyati">Sirdaryo</option>
            <option value="Surxondaryo viloyati">Surxondaryo</option>
            <option value="Toshkent viloyati">Toshkent vil.</option>
            <option value="Xorazm viloyati">Xorazm</option>
            <option value="Toshkent shahar">Toshkent sh.</option>
          </select>
        </div>
      </div>
      <div v-if="loading" class="obj-loading">
        <div class="ld-grid">
          <div class="ld-card" v-for="i in 6" :key="i">
            <div class="ld-img shimmer"></div>
            <div class="ld-body">
              <div class="ld-line shimmer" style="width:70%"></div>
              <div class="ld-line shimmer" style="width:45%"></div>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="cards-grid">
        <div v-for="obj in objects" :key="obj.id" class="obj-card" @click="openDetail(obj)">
          <div class="oc-ribbon" :style="{ background: typeColor(obj.obj_type) }"></div>
          <div class="oc-img" @click.stop="openObjGallery(obj)">
            <img v-if="obj.photos && obj.photos.length" :src="obj.photos[0]" :alt="obj.obj_name" @error="imgErr"/>
            <div v-else class="oc-noimg" :style="{ background: typeGradient(obj.obj_type) }">
              <svg viewBox="0 0 24 24" fill="none" stroke="rgba(255,255,255,0.4)" stroke-width="1.2">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
                <polyline points="21 15 16 10 5 21"/>
              </svg>
            </div>
            <div class="oc-overlay">
              <div class="oc-gallery-hint" v-if="obj.photos && obj.photos.length > 1">
                <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                  <rect x="3" y="3" width="18" height="18" rx="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
                {{ obj.photos.length }} ta rasm
              </div>
              <button class="oc-map-btn" @click.stop="goToMap(obj)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z"/>
                </svg>
                Xaritada
              </button>
            </div>
            <div class="oc-type-badge" :style="{ background: typeColor(obj.obj_type) }">{{
                shortType(obj.obj_type)
              }}
            </div>
            <div class="oc-photo-count" v-if="obj.photos && obj.photos.length > 1">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" style="width:9px;height:9px">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
              </svg>
              {{ obj.photos.length }}
            </div>
          </div>
          <div class="oc-body">
            <h3 class="oc-name">{{ obj.obj_name || "Noma'lum" }}</h3>
            <div class="oc-loc">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                <circle cx="12" cy="10" r="3"/>
              </svg>
              <span>{{ obj.region_name || '&#8212;' }}<em v-if="obj.district_name"> &middot; {{
                  obj.district_name
                }}</em></span></div>
            <div class="oc-period" v-if="obj.obj_period">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10"/>
                <polyline points="12 6 12 12 16 14"/>
              </svg>
              {{ obj.obj_period }}
            </div>
            <div class="oc-infra">
              <span class="inf-chip" :class="obj.electricity==='yes' ? 'inf-yes':'inf-no'">&#9889; {{
                  obj.electricity === 'yes' ? 'Elektr' : 'Elektrsiz'
                }}</span>
              <span class="inf-chip" :class="obj.natural_gas==='yes' ? 'inf-yes':'inf-no'">&#128293; {{
                  obj.natural_gas === 'yes' ? 'Gaz' : 'Gazsiz'
                }}</span>
            </div>
            <div class="oc-footer">
              <button class="ocf-btn ocf-detail" @click.stop="openDetail(obj)">Batafsil
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <polyline points="9 18 15 12 9 6"/>
                </svg>
              </button>
              <button class="ocf-btn ocf-gallery" @click.stop="openObjGallery(obj)"
                      v-if="obj.photos && obj.photos.length">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <rect x="3" y="3" width="18" height="18" rx="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
              </button>
              <button class="ocf-btn ocf-map" @click.stop="goToMap(obj)">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z"/>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
      <div v-if="!loading && objects.length === 0" class="empty-state">
        <div class="es-icon">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
            <circle cx="11" cy="11" r="8"/>
            <path d="m21 21-4.35-4.35"/>
          </svg>
        </div>
        <p>Hech narsa topilmadi</p>
        <button class="btn-secondary" @click="resetAll">Filtrlarni tozalash</button>
      </div>
      <div class="pagination" v-if="totalPages > 1 && !loading">
        <button class="pg-btn" :disabled="currentPage===1" @click="changePage(currentPage-1)">&#8249;</button>
        <button v-for="p in visiblePages" :key="p" class="pg-btn" :class="{ active: p===currentPage, dots: p==='...' }"
                :disabled="p==='...'" @click="p!=='...' && changePage(p)">{{ p }}
        </button>
        <button class="pg-btn" :disabled="currentPage===totalPages" @click="changePage(currentPage+1)">&#8250;</button>
      </div>
      <div class="view-all-wrap">
        <router-link to="/map" class="view-all-btn">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z"/>
          </svg>
          Barcha obyektlarni xaritada ko‘rish
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <polyline points="9 18 15 12 9 6"/>
          </svg>
        </router-link>
      </div>
    </section>

    <section class="regions-section">
      <div class="sec-head">
        <div class="sh-tag">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
            <circle cx="12" cy="10" r="3"/>
          </svg>
          HUDUD (RESPUBLIKA / VILOYAT)
        </div>
        <h2 class="sh-title">Geografik Taqsimot</h2>
      </div>
      <div class="regions-grid">
        <div v-for="r in regions" :key="r.name" class="region-card" @click="goRegion(r.name)">
          <div class="rc-bar" :style="{ width: (r.count/maxRegionCount*100)+'%', background: r.color }"></div>
          <div class="rc-content"><span class="rc-name">{{ r.short }}</span><span class="rc-count">{{ r.count }}</span>
          </div>
          <div class="rc-arrow">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="9 18 15 12 9 6"/>
            </svg>
          </div>
        </div>
      </div>
    </section>

    <transition name="modal-fade">
      <div v-if="detailObj" class="modal-ov" @click.self="closeDetail">
        <div class="modal-box">
          <button class="modal-x" @click="closeDetail">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
          <div class="d-hero" :style="{ background: typeGradient(detailObj.obj_type) }"
               @click="openObjGallery(detailObj)" style="cursor:pointer">
            <img v-if="detailObj.photos && detailObj.photos.length" :src="detailObj.photos[0]" :alt="detailObj.obj_name"
                 @error="imgErr"/>
            <div class="d-hero-overlay"></div>
            <div class="d-hero-gallery-hint" v-if="detailObj.photos && detailObj.photos.length > 1">
              <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                <rect x="3" y="3" width="18" height="18" rx="2"/>
                <circle cx="8.5" cy="8.5" r="1.5"/>
              </svg>
              {{ detailObj.photos.length }} ta rasm ko‘rish
            </div>
            <div class="d-hero-txt">
              <span class="d-tag" :style="{ background: typeColor(detailObj.obj_type) }">{{ detailObj.obj_type }}</span>
              <h2>{{ detailObj.obj_name || "Noma'lum" }}</h2>
              <p v-if="detailObj.obj_period">&#x1F570; {{ detailObj.obj_period }}</p>
            </div>
          </div>
          <div class="d-body">
            <div class="info-grid">
              <div class="ig-item" v-if="detailObj.region_name"><span>Hudud</span><strong>{{
                  detailObj.region_name
                }}</strong></div>
              <div class="ig-item" v-if="detailObj.district_name"><span>Tuman</span><strong>{{
                  detailObj.district_name
                }}</strong></div>
              <div class="ig-item" v-if="detailObj.obj_func"><span>Maqsadi</span><strong>{{
                  detailObj.obj_func
                }}</strong></div>
              <div class="ig-item" v-if="detailObj.residential"><span>Tasnifi</span><strong>{{
                  detailObj.residential
                }}</strong></div>
              <div class="ig-item" v-if="detailObj.address" style="grid-column:1/-1">
                <span>Manzil</span><strong>{{ detailObj.address }}</strong></div>
            </div>
          </div>
          <div class="d-photo-strip" v-if="detailObj.photos && detailObj.photos.length > 1">
            <div v-for="(ph, i) in detailObj.photos.slice(0,6)" :key="i" class="dps-thumb"
                 @click="openObjGallery(detailObj, i)"><img :src="ph" @error="imgErr"/></div>
            <div class="dps-more" v-if="detailObj.photos.length > 6" @click="openObjGallery(detailObj, 6)">
              +{{ detailObj.photos.length - 6 }}
            </div>
          </div>
          <div class="d-footer">
            <router-link to="/map" class="dfbtn dfbtn-map" @click.native="closeDetail">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M1 6v16l7-4 8 4 7-4V2l-7 4-8-4-7 4z"/>
              </svg>
              Xaritada Ko‘rish
            </router-link>
            <button class="dfbtn dfbtn-sec" @click="closeDetail">Yopish</button>
          </div>
        </div>
      </div>
    </transition>

    <section class="artifacts-section" id="artifacts-section">
      <div class="art-inner">
        <div class="sec-head">
          <div class="sh-left">
            <div class="sh-tag">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M12 2a10 10 0 1 0 10 10M12 8v4l3 3"/>
                <circle cx="18" cy="6" r="3" fill="#c8813a" stroke="none"/>
              </svg>
              Arxeologik Artefaktlar
            </div>
            <h2 class="sh-title">Tasdiqlangan Topilmalar</h2>
          </div>
          <div class="sh-right art-meta" v-if="artifactTotal"><span class="art-total-badge">Jami: {{
              artifactTotal
            }}</span></div>
        </div>
        <div class="art-filter-row">
          <div class="search-box">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <input v-model="artSearch" @input="debounceArtSearch" type="text"
                   placeholder="Artefakt nomi yoki inventar raqami..."/>
            <button v-if="artSearch" class="search-clear" @click="clearArtSearch">&#215;</button>
          </div>
          <div class="region-sel">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            <select v-model="artRegion" @change="artPage=1; fetchArtifacts()">

                <option data-v-a98253d4="" value="">Barcha hududlar</option>
                <option data-v-a98253d4="" value="Qoraqalpogʻiston Respublikasi">Qoraqalpog'iston</option>
                <option data-v-a98253d4="" value="Andijon viloyati">Andijon</option>
                <option data-v-a98253d4="" value="Buxora viloyati">Buxoro</option>
                <option data-v-a98253d4="" value="Fargʻona viloyati">Farg'ona</option>
                <option data-v-a98253d4="" value="Jizzax viloyati">Jizzax</option>
                <option data-v-a98253d4="" value="Namangan viloyati">Namangan</option>
                <option data-v-a98253d4="" value="Qashqadaryo viloyati">Qashqadaryo</option>
                <option data-v-a98253d4="" value="Navoiy viloyati">Navoiy</option>
                <option data-v-a98253d4="" value="Samarqand viloyati">Samarqand</option>
                <option data-v-a98253d4="" value="Sirdaryo viloyati">Sirdaryo</option>
                <option data-v-a98253d4="" value="Surxondaryo viloyati">Surxondaryo</option>
                <option data-v-a98253d4="" value="Toshkent viloyati">Toshkent vil.</option>
                <option data-v-a98253d4="" value="Xorazm viloyati">Xorazm</option>
                <option data-v-a98253d4="" value="Toshkent shahar">Toshkent sh.</option>

            </select>
          </div>
          <div class="region-sel">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
            <select v-model="artMaterial" @change="artPage=1; fetchArtifacts()">
              <option value="">Barcha material</option>
              <option value="Metall">Metall</option>
              <option value="Boshqa">Boshqa</option>
              <option value="Sopol">Sopol</option>
              <option value="Tosh">Tosh</option>
              <option value="Shisha">Shisha</option>
              <option value="Yog'och">Yog'och</option>
            </select>
          </div>
        </div>
        <div v-if="artLoading" class="obj-loading">
          <div class="art-ld-grid">
            <div class="art-ld-card" v-for="i in 8" :key="i">
              <div class="art-ld-img shimmer"></div>
              <div class="ld-body">
                <div class="ld-line shimmer" style="width:60%"></div>
                <div class="ld-line shimmer" style="width:40%"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="artifacts.length" class="art-grid">
          <div v-for="a in artifacts" :key="a.id" class="art-card" @click="openArtifact(a)">
            <div class="art-card-img" @click.stop="openArtifactGallery(a)">
              <img v-if="a.tasvir_1" :src="a.tasvir_1" :alt="a.nomi" @error="imgErr"/>
              <div v-else class="art-noimg">
                <svg viewBox="0 0 24 24" fill="none" stroke="rgba(200,129,58,0.4)" stroke-width="1.2">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M12 8v4M12 16h.01"/>
                </svg>
              </div>
              <div class="art-overlay">
                <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="m21 21-4.35-4.35"/>
                  <line x1="11" y1="8" x2="11" y2="14"/>
                  <line x1="8" y1="11" x2="14" y2="11"/>
                </svg>
              </div>
              <!--              <div class="art-holat" :class="a.texnik_holati==='Butun' ? 'holat-yax' : 'holat-kem'">{{ a.texnik_holati }}</div>-->
              <!--              <div class="art-inv">{{ a.inventar_raqami }}</div>-->
              <div class="art-photo-count" v-if="artifactPhotos(a).length > 1">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     style="width:8px;height:8px">
                  <rect x="3" y="3" width="18" height="18" rx="2"/>
                </svg>
                {{ artifactPhotos(a).length }}
              </div>
            </div>
            <div class="art-body">
              <h4 class="art-name">{{ a.nomi }}</h4>
              <div class="art-meta-row">
                <span class="art-davr"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle
                    cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>{{ a.davri }}</span>
                <span class="art-mat" v-if="a.materiali">{{ a.materiali }}</span>
              </div>
              <div class="art-loc">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                <span>{{ a.viloyat ? a.viloyat.replace(' viloyati', '') : '&#8212;' }}</span></div>
              <div class="art-footer">
                <div class="art-actions">
                  <!--                  <a v-if="a.pasport" :href="a.pasport" target="_blank" class="art-btn art-btn-pdf" @click.stop><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>PDF</a>-->
                  <button class="art-btn art-btn-detail" @click.stop="openArtifact(a)">Batafsil
                    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                      <polyline points="9 18 15 12 9 6"/>
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="!artLoading" class="empty-state">
          <div class="es-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
          </div>
          <p>Artefaktlar topilmadi</p>
          <button class="btn-secondary" @click="resetArtFilters">Filtrlarni tozalash</button>
        </div>
        <div class="pagination" v-if="artTotalPages > 1 && !artLoading">
          <button class="pg-btn" :disabled="artPage===1" @click="changeArtPage(artPage-1)">&#8249;</button>
          <button v-for="p in visibleArtPages" :key="p" class="pg-btn" :class="{ active: p===artPage, dots: p==='...' }"
                  :disabled="p==='...'" @click="p!=='...' && changeArtPage(p)">{{ p }}
          </button>
          <button class="pg-btn" :disabled="artPage===artTotalPages" @click="changeArtPage(artPage+1)">&#8250;</button>
        </div>
      </div>
    </section>

    <section class="museum-catalog-section" id="museum-catalog-section">
      <div class="mc-inner">
        <div class="sec-head">
          <div class="sh-left">
            <div class="sh-tag">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                <polyline points="9 22 9 12 15 12 15 22"/>
              </svg>
              Muzey Fondi
            </div>
            <h2 class="sh-title">Davlat muzey kataloglari</h2>
          </div>
        </div>
        <div class="mc-filter-row">
          <div class="search-box">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <input v-model="catSearch" @input="debounceCatSearch" type="text"
                   placeholder="Buyum nomi, KP raqami, material..."/>
            <button v-if="catSearch" class="search-clear" @click="clearCatSearch">&#215;</button>
          </div>
          <div class="region-sel">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
            </svg>
            <select v-model="catMaterial" @change="catPage=1; fetchCatalog()">
              <option value="">Barcha material</option>
              <option value="Сопол">Sopol</option>
              <option value="Мис">Mis</option>
              <option value="Тош">Tosh</option>
              <option value="Қоғоз">Qog'oz</option>
              <option value="Табиий">Tabiiy</option>
              <option value="Металл">Metall</option>
            </select>
          </div>
          <div class="region-sel">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 6h18M6 12h12M9 18h6"/>
            </svg>
            <select v-model="catSort" @change="catPage=1; fetchCatalog()">
              <option value="-count">Ko‘p sonli</option>
              <option value="count">Kam sonli</option>
              <option value="-created_at">Yangi</option>
            </select>
          </div>
        </div>
        <div v-if="catLoading" class="cat-loading">
          <div class="cat-ld-grid">
            <div class="cat-ld-row" v-for="i in 6" :key="i">
              <div class="cld-img shimmer"></div>
              <div class="cld-body">
                <div class="ld-line shimmer" style="width:55%"></div>
                <div class="ld-line shimmer" style="width:35%;margin-top:6px"></div>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="catalogItems.length" class="cat-grid">
          <div v-for="item in catalogItems" :key="item.id" class="cat-card" @click="openCatalogItem(item)">
            <div class="cat-img-wrap" @click.stop="openCatalogGallery(item)">
              <img v-if="item.image && item.image[0]"
                   :src="item.image[0].thumbnails && item.image[0].thumbnails.small ? item.image[0].thumbnails.small.src : item.image[0].link"
                   :alt="item.title" @error="imgErr"/>
              <div v-else class="cat-noimg">
                <svg viewBox="0 0 24 24" fill="none" stroke="rgba(46,134,171,0.3)" stroke-width="1">
                  <rect x="3" y="3" width="18" height="18" rx="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
              </div>
              <div class="cat-count-badge">{{ item.count ? item.count.toLocaleString() : 0 }} dona</div>
              <div class="cat-overlay">
                <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" style="width:22px;height:22px">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="m21 21-4.35-4.35"/>
                  <line x1="11" y1="8" x2="11" y2="14"/>
                  <line x1="8" y1="11" x2="14" y2="11"/>
                </svg>
              </div>
              <div class="cat-photo-count" v-if="item.image && item.image.length > 1">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     style="width:8px;height:8px">
                  <rect x="3" y="3" width="18" height="18" rx="2"/>
                </svg>
                {{ item.image.length }}
              </div>
            </div>
            <div class="cat-body">
              <div class="cat-kp">{{ item.kp }}</div>
              <h4 class="cat-title">{{ item.title || item.fullname || "Noma'lum" }}</h4>
              <div class="cat-meta">
                <span v-if="item.dating" class="cat-chip cat-chip-date"><svg viewBox="0 0 24 24" fill="none"
                                                                             stroke="currentColor" stroke-width="2"
                                                                             style="width:10px;height:10px"><circle
                    cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>{{ item.dating }}</span>
                <span v-if="item.material" class="cat-chip cat-chip-mat">{{ item.material }}</span>
              </div>
              <div class="cat-museum" v-if="item.museum && item.museum.title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     style="width:10px;height:10px;flex-shrink:0">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                </svg>
                {{ item.museum.title.length > 35 ? item.museum.title.slice(0, 35) + '...' : item.museum.title }}
              </div>
              <div class="cat-production" v-if="item.production">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     style="width:10px;height:10px;flex-shrink:0">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                {{ item.production }}
              </div>
              <div class="cat-footer">
                <span class="cat-storage" v-if="item.storage">{{ item.storage }}</span>
                <button class="cat-detail-btn" @click.stop="openCatalogItem(item)">Ko‘rish
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                       style="width:11px;height:11px">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
        <div v-else-if="!catLoading" class="empty-state">
          <div class="es-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
          </div>
          <p>Buyumlar topilmadi</p>
          <button class="btn-secondary" @click="resetCatFilters">Filtrlarni tozalash</button>
        </div>
        <div class="pagination" v-if="catTotalPages > 1 && !catLoading">
          <button class="pg-btn" :disabled="catPage===1" @click="changeCatPage(catPage-1)">&#8249;</button>
          <button v-for="p in visibleCatPages" :key="p" class="pg-btn" :class="{ active: p===catPage, dots: p==='...' }"
                  :disabled="p==='...'" @click="p!=='...' && changeCatPage(p)">{{ p }}
          </button>
          <button class="pg-btn" :disabled="catPage===catTotalPages" @click="changeCatPage(catPage+1)">&#8250;</button>
        </div>
      </div>
    </section>

    <transition name="modal-fade">
      <div v-if="catalogDetail" class="modal-ov" @click.self="closeCatalogItem">
        <div class="modal-box cat-modal-box">
          <button class="modal-x" @click="closeCatalogItem">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
          <div class="amd-gallery">
            <div class="amd-main-photo" style="background:linear-gradient(135deg,#0a1a2e,#0d2e4a);cursor:pointer"
                 @click="openCatalogGallery(catalogDetail)">
              <img v-if="catActivePhoto" :src="catActivePhoto" :alt="catalogDetail.title" @error="imgErr"/>
              <div v-else class="amd-nophoto">
                <svg viewBox="0 0 24 24" fill="none" stroke="rgba(46,134,171,0.3)" stroke-width="1">
                  <rect x="3" y="3" width="18" height="18" rx="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
              </div>
              <div class="amd-photo-overlay"></div>
              <div class="amd-title-overlay">
                <div class="amd-inv-badge"
                     style="background:rgba(46,134,171,.28);color:#5bc0e8;border-color:rgba(46,134,171,.38)">
                  {{ catalogDetail.kp }}
                </div>
                <h2>{{ catalogDetail.title || catalogDetail.fullname || "Noma'lum" }}</h2>
                <span class="amd-davr" style="color:rgba(91,192,232,0.9)">{{ catalogDetail.dating }}</span>
              </div>
            </div>
            <div class="amd-thumbs" v-if="catalogPhotos(catalogDetail).length > 1">
              <div v-for="(ph,i) in catalogPhotos(catalogDetail)" :key="i" class="amd-thumb"
                   :class="{ active: catActivePhoto===ph }" @click="catActivePhoto=ph"><img :src="ph" @error="imgErr"/>
              </div>
            </div>
          </div>
          <div class="amd-body">
            <div class="amd-section">
              <div class="amd-sec-title" style="color:#2e86ab">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                Asosiy ma’lumotlar
              </div>
              <div class="info-grid">
                <div class="ig-item" v-if="catalogDetail.kp"><span>KP raqami</span><strong>{{
                    catalogDetail.kp
                  }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.inv"><span>Inventar</span><strong>{{
                    catalogDetail.inv
                  }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.dating"><span>Davri</span><strong>{{
                    catalogDetail.dating
                  }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.material">
                  <span>Materiali</span><strong>{{ catalogDetail.material }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.size"><span>O‘lchami</span><strong>{{
                    catalogDetail.size
                  }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.count">
                  <span>Soni</span><strong>{{ catalogDetail.count.toLocaleString() }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.keeping"><span>Holati</span><strong>{{
                    catalogDetail.keeping
                  }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.equipment" style="grid-column:1/-1">
                  <span>Tayyorlash usuli</span><strong>{{ catalogDetail.equipment }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.description" style="grid-column:1/-1">
                  <span>Tavsif</span><strong>{{ catalogDetail.description }}</strong></div>
              </div>
            </div>
            <div class="amd-section" v-if="catalogDetail.museum">
              <div class="amd-sec-title" style="color:#2e86ab">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/>
                </svg>
                Muzey ma’lumotlari
              </div>
              <div class="info-grid">
                <div class="ig-item" style="grid-column:1/-1">
                  <span>Muzey nomi</span><strong>{{ catalogDetail.museum.title }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.museum.address" style="grid-column:1/-1">
                  <span>Manzil</span><strong>{{ catalogDetail.museum.address }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.museum.schedule_museum">
                  <span>Ish vaqti</span><strong>{{ catalogDetail.museum.schedule_museum }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.museum.count_exhbition"><span>Eksponatlar soni</span><strong>{{
                    Number(catalogDetail.museum.count_exhbition).toLocaleString()
                  }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.storage">
                  <span>Saqlash joyi</span><strong>{{ catalogDetail.storage }}</strong></div>
                <div class="ig-item" v-if="catalogDetail.production">
                  <span>Topilgan joy</span><strong>{{ catalogDetail.production }}</strong></div>
              </div>
            </div>
          </div>
          <div class="d-footer">
            <button class="dfbtn dfbtn-sec" @click="closeCatalogItem">Yopish</button>
          </div>
        </div>
      </div>
    </transition>

    <transition name="modal-fade">
      <div v-if="artifactDetail" class="modal-ov" @click.self="closeArtifact">
        <div class="modal-box art-modal-box">
          <button class="modal-x" @click="closeArtifact">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
          <div class="amd-gallery">
            <div class="amd-main-photo" @click="openArtifactGallery(artifactDetail)" style="cursor:pointer">
              <img v-if="artActivePhoto" :src="artActivePhoto" :alt="artifactDetail.nomi" @error="imgErr"/>
              <div v-else class="amd-nophoto">
                <svg viewBox="0 0 24 24" fill="none" stroke="rgba(200,129,58,0.3)" stroke-width="1">
                  <rect x="3" y="3" width="18" height="18" rx="2"/>
                  <circle cx="8.5" cy="8.5" r="1.5"/>
                  <polyline points="21 15 16 10 5 21"/>
                </svg>
              </div>
              <div class="amd-photo-overlay"></div>
              <div class="amd-title-overlay">
                <div class="amd-inv-badge">{{ artifactDetail.inventar_raqami }}</div>
                <h2>{{ artifactDetail.nomi }}</h2>
                <span class="amd-davr">{{ artifactDetail.davri }}</span>
              </div>
            </div>
            <div class="amd-thumbs" v-if="artifactPhotos(artifactDetail).length > 1">
              <div v-for="(ph,i) in artifactPhotos(artifactDetail)" :key="i" class="amd-thumb"
                   :class="{ active: artActivePhoto===ph }" @click="artActivePhoto=ph"><img :src="ph" @error="imgErr"/>
              </div>
            </div>
          </div>
          <div class="amd-body">
            <div class="amd-section">
              <div class="amd-sec-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                Asosiy ma’lumotlar
              </div>
              <div class="info-grid">
                <!--                <div class="ig-item" v-if="artifactDetail.inventar_raqami"><span>Inventar raqam</span><strong>{{ artifactDetail.inventar_raqami }}</strong></div>-->
                <div class="ig-item" v-if="artifactDetail.davri"><span>Davri</span><strong>{{
                    artifactDetail.davri
                  }}</strong></div>
                <!--                <div class="ig-item" v-if="artifactDetail.texnik_holati"><span>Holati</span><strong :class="artifactDetail.texnik_holati==='Butun'?'yes-txt':'warn-txt'">{{ artifactDetail.texnik_holati }}</strong></div>-->
                <div class="ig-item" v-if="artifactDetail.materiali">
                  <span>Materiali</span><strong>{{ artifactDetail.materiali }}</strong></div>
              </div>
            </div>
          </div>
          <!--          <div class="d-footer">-->
          <!--            <a v-if="artifactDetail.pasport" :href="artifactDetail.pasport" target="_blank" class="dfbtn dfbtn-map"><svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/></svg>PDF Pasport</a>-->
          <!--            <button class="dfbtn dfbtn-sec" @click="closeArtifact">Yopish</button>-->
          <!--          </div>-->
        </div>
      </div>
    </transition>

    <!-- ══════════════ MADANIY BOYLIKLAR ══════════════ -->
    <section class="cw-pub-section" id="cultural-wealth-section">
      <div class="cw-pub-inner">
        <div class="sec-head">
          <div class="sh-left">
            <div class="sh-tag">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <path
                    d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 2 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>
              </svg>
              Xorijdagi madaniy boyliklar
            </div>
            <h2 class="sh-title">O‘zbekistonga oid xorijdagi madaniy boyliklar</h2>
          </div>
          <div class="sh-right">
            <div class="cw-pub-stats-row" v-if="!cwLoading">
              <div v-for="t in cwTabs" :key="'stat-'+t.key" class="cw-pub-stat-pill">
                <span class="cw-pub-stat-dot" :style="{ background: t.color }"></span>
                <span class="cw-pub-stat-label">{{ t.shortLabel }}</span>
                <span class="cw-pub-stat-num" :style="{ color: t.color }">{{
                    (cwCounts[t.key] || 0).toLocaleString()
                  }}</span>
              </div>
            </div>
          </div>
        </div>

        <div class="cw-pub-tabs-wrap">
          <div class="cw-pub-tabs">
            <button v-for="t in cwTabs" :key="t.key" class="cw-pub-tab" :class="{ active: cwActiveTab === t.key }"
                    @click="cwSwitchTab(t.key)"
                    :style="cwActiveTab===t.key ? { borderColor: t.color, color: t.color, background: t.color+'18' } : {}">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8"
                   :style="{ width:'14px', height:'14px', stroke: cwActiveTab===t.key ? t.color : '#6a7a6e' }"
                   v-html="t.icon"></svg>
              {{ t.label }}
              <span class="cw-pub-tab-cnt"
                    :style="cwActiveTab===t.key ? { background: t.color+'28', color: t.color } : {}">{{
                  (cwCounts[t.key] || 0).toLocaleString()
                }}</span>
            </button>
          </div>
        </div>

        <div class="cw-pub-filter-row">
          <div class="search-box" style="flex:1;min-width:220px;">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
            <input v-model="cwSearch" @input="debounceCwSearch" type="text"
                   placeholder="Qidirish: nomi, inventar raqami, joylashuv..."/>
            <button v-if="cwSearch" class="search-clear" @click="cwClearSearch">&#215;</button>
          </div>
          <div class="region-sel">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
              <circle cx="12" cy="10" r="3"/>
            </svg>
            <select v-model="cwFilterCountry" @change="cwPage=1; cwFetch()">
              <option value="">Barcha davlatlar</option>
              <option value="O‘zbekiston">O‘zbekiston</option>
              <option value="Rossiya">Rossiya</option>
              <option value="Germaniya">Germaniya</option>
              <option value="Fransiya">Fransiya</option>
              <option value="Buyuk Britaniya">Buyuk Britaniya</option>
            </select>
          </div>
          <div class="region-sel">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M3 6h18M6 12h12M9 18h6"/>
            </svg>
            <select v-model="cwSort" @change="cwPage=1; cwFetch()">
              <option value="">Standart tartib</option>
              <option value="name">Nomi (A-Z)</option>
              <option value="-name">Nomi (Z-A)</option>
              <option value="inventory_no">Inventar raqami</option>
            </select>
          </div>
          <button class="cw-pub-reset-btn" @click="cwResetFilters" title="Filtrlarni tozalash">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <polyline points="1 4 1 10 7 10"/>
              <path d="M3.51 15a9 9 0 1 0 .49-3.51"/>
            </svg>
          </button>
        </div>

        <div v-if="cwLoading" class="obj-loading">
          <div class="cw-pub-ld-grid">
            <div class="cw-pub-ld-card" v-for="i in 8" :key="i">
              <div class="ld-img shimmer" style="height:130px;"></div>
              <div class="ld-body" style="padding:.75rem;">
                <div class="ld-line shimmer" style="width:65%;height:11px;"></div>
                <div class="ld-line shimmer" style="width:40%;height:9px;margin-top:6px;"></div>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="cwItems.length" class="cw-pub-grid">
          <div v-for="item in cwItems" :key="item.id" class="cw-pub-card" :style="{ '--tab-color': cwCurrentTab.color }"
               @click="cwOpenDetail(item)">
            <div class="cw-pub-card-ribbon" :style="{ background: cwCurrentTab.color }"></div>
            <div class="cw-pub-card-img">
              <img v-if="cwItemPhoto(item)" :src="cwItemPhoto(item)" :alt="cwItemTitle(item)" @error="imgErr"/>
              <div v-else class="cw-pub-card-noimg" :style="{ background: cwCurrentTab.color+'18' }">
                <svg viewBox="0 0 24 24" fill="none" :stroke="cwCurrentTab.color" stroke-width="1"
                     style="width:36px;height:36px;opacity:.5" v-html="cwCurrentTab.icon"></svg>
              </div>
              <div class="cw-pub-card-overlay">
                <svg viewBox="0 0 24 24" fill="none" stroke="white" stroke-width="2" style="width:22px;height:22px">
                  <circle cx="11" cy="11" r="8"/>
                  <path d="m21 21-4.35-4.35"/>
                  <line x1="11" y1="8" x2="11" y2="14"/>
                  <line x1="8" y1="11" x2="14" y2="11"/>
                </svg>
              </div>
              <div class="cw-pub-card-type-badge" :style="{ background: cwCurrentTab.color }">{{
                  cwCurrentTab.shortLabel
                }}
              </div>
              <div class="cw-pub-card-inv" v-if="item.inventory_no">{{ item.inventory_no }}</div>
            </div>
            <div class="cw-pub-card-body">
              <h4 class="cw-pub-card-name">{{ cwItemTitle(item) }}</h4>
              <div class="cw-pub-card-meta">
                <span class="cw-pub-meta-item" v-if="item.country || item.city"><svg viewBox="0 0 24 24" fill="none"
                                                                                     stroke="currentColor"
                                                                                     stroke-width="2"
                                                                                     style="width:10px;height:10px;flex-shrink:0"><path
                    d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>{{
                    [item.city, item.country].filter(Boolean).join(', ') || '—'
                  }}</span>
                <span class="cw-pub-meta-item" v-if="cwItemDate(item)"><svg viewBox="0 0 24 24" fill="none"
                                                                            stroke="currentColor" stroke-width="2"
                                                                            style="width:10px;height:10px;flex-shrink:0"><circle
                    cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>{{ cwItemDate(item) }}</span>
                <span class="cw-pub-meta-item" v-if="cwItemMaterial(item)"><svg viewBox="0 0 24 24" fill="none"
                                                                                stroke="currentColor" stroke-width="2"
                                                                                style="width:10px;height:10px;flex-shrink:0"><path
                    d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/></svg>{{ cwItemMaterial(item) }}</span>
              </div>
              <div class="cw-pub-card-chips">
                <span v-if="item.fond" class="cw-pub-chip">{{ item.fond }}</span>
                <span v-if="item.collection" class="cw-pub-chip">{{ item.collection }}</span>
                <span v-if="item.organization" class="cw-pub-chip">{{ item.organization }}</span>
              </div>
              <div class="cw-pub-card-footer">
                <button class="cw-pub-detail-btn"
                        :style="{ color: cwCurrentTab.color, borderColor: cwCurrentTab.color+'44', background: cwCurrentTab.color+'10' }">
                  Batafsil
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                       style="width:11px;height:11px">
                    <polyline points="9 18 15 12 9 6"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="!cwLoading" class="empty-state">
          <div class="es-icon">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
              <circle cx="11" cy="11" r="8"/>
              <path d="m21 21-4.35-4.35"/>
            </svg>
          </div>
          <p>{{ cwCurrentTab.label }} topilmadi</p>
          <button class="btn-secondary" @click="cwResetFilters">Filtrlarni tozalash</button>
        </div>

        <div class="pagination" v-if="cwTotalPages > 1 && !cwLoading">
          <button class="pg-btn" :disabled="cwPage===1" @click="cwChangePage(cwPage-1)">&#8249;</button>
          <button v-for="p in cwVisiblePages" :key="p" class="pg-btn" :class="{ active: p===cwPage, dots: p==='...' }"
                  :disabled="p==='...'"
                  :style="p===cwPage ? { background: cwCurrentTab.color+'33', borderColor: cwCurrentTab.color, color: cwCurrentTab.color } : {}"
                  @click="p!=='...' && cwChangePage(p)">{{ p }}
          </button>
          <button class="pg-btn" :disabled="cwPage===cwTotalPages" @click="cwChangePage(cwPage+1)">&#8250;</button>
        </div>
      </div>
    </section>

    <transition name="modal-fade">
      <div v-if="cwDetail" class="modal-ov" @click.self="cwCloseDetail">
        <div class="modal-box cw-detail-modal-box">
          <button class="modal-x" @click="cwCloseDetail">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </button>
          <div class="d-hero"
               :style="{ background: 'linear-gradient(135deg,'+cwCurrentTab.color+'55,'+cwCurrentTab.color+'22)' }">
            <img v-if="cwItemPhoto(cwDetail)" :src="cwItemPhoto(cwDetail)" :alt="cwItemTitle(cwDetail)"
                 @error="imgErr"/>
            <div class="d-hero-overlay"></div>
            <div class="d-hero-txt">
              <span class="d-tag" :style="{ background: cwCurrentTab.color }">{{ cwCurrentTab.label }}</span>
              <h2>{{ cwItemTitle(cwDetail) }}</h2>
              <p v-if="cwDetail.inventory_no">&#x1F4CB; {{ cwDetail.inventory_no }}</p>
            </div>
          </div>
          <div class="d-body">
            <div class="cw-modal-section"
                 v-if="cwDetail.continent||cwDetail.country||cwDetail.city||cwDetail.organization||cwDetail.fond||cwDetail.collection">
              <div class="cw-modal-sec-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     style="width:12px;height:12px">
                  <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/>
                  <circle cx="12" cy="10" r="3"/>
                </svg>
                Joylashuv
              </div>
              <div class="info-grid">
                <div class="ig-item" v-if="cwDetail.continent"><span>Kontinent</span><strong>{{
                    cwDetail.continent
                  }}</strong></div>
                <div class="ig-item" v-if="cwDetail.country"><span>Davlat</span><strong>{{ cwDetail.country }}</strong>
                </div>
                <div class="ig-item" v-if="cwDetail.city"><span>Shahar</span><strong>{{ cwDetail.city }}</strong></div>
                <div class="ig-item" v-if="cwDetail.organization"><span>Tashkilot</span><strong>{{
                    cwDetail.organization
                  }}</strong></div>
                <div class="ig-item" v-if="cwDetail.fond"><span>Fond</span><strong>{{ cwDetail.fond }}</strong></div>
                <div class="ig-item" v-if="cwDetail.collection"><span>Kolleksiya</span><strong>{{
                    cwDetail.collection
                  }}</strong></div>
                <div class="ig-item" v-if="cwDetail.storage_place">
                  <span>Saqlanish joyi</span><strong>{{ cwDetail.storage_place }}</strong></div>
                <div class="ig-item" v-if="cwDetail.found_place">
                  <span>Topilgan joy</span><strong>{{ cwDetail.found_place }}</strong></div>
              </div>
            </div>
            <div class="cw-modal-section">
              <div class="cw-modal-sec-title" :style="{ color: cwCurrentTab.color }">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     style="width:12px;height:12px">
                  <circle cx="12" cy="12" r="10"/>
                  <line x1="12" y1="8" x2="12" y2="12"/>
                  <line x1="12" y1="16" x2="12.01" y2="16"/>
                </svg>
                Asosiy ma’lumotlar
              </div>
              <div class="info-grid">
                <div class="ig-item" v-if="cwDetail.inventory_no">
                  <span>Inventar raqami</span><strong>{{ cwDetail.inventory_no }}</strong></div>
                <div class="ig-item" v-if="cwItemDate(cwDetail)">
                  <span>Davri / Sanasi</span><strong>{{ cwItemDate(cwDetail) }}</strong></div>
                <div class="ig-item" v-if="cwItemMaterial(cwDetail)">
                  <span>Materiali</span><strong>{{ cwItemMaterial(cwDetail) }}</strong></div>
                <div class="ig-item" v-if="cwDetail.size"><span>O‘lchami</span><strong>{{ cwDetail.size }}</strong>
                </div>
                <div class="ig-item" v-if="cwDetail.author||cwDetail.music_author">
                  <span>Muallif</span><strong>{{ cwDetail.author || cwDetail.music_author }}</strong></div>
                <div class="ig-item" v-if="cwDetail.language"><span>Til</span><strong>{{ cwDetail.language }}</strong>
                </div>
                <div class="ig-item" v-if="cwDetail.pages_count"><span>Varaq soni</span><strong>{{
                    cwDetail.pages_count
                  }}</strong></div>
                <div class="ig-item" v-if="cwDetail.script_type"><span>Xat turi</span><strong>{{
                    cwDetail.script_type
                  }}</strong></div>
                <div class="ig-item" v-if="cwDetail.metal"><span>Metall</span><strong>{{ cwDetail.metal }}</strong>
                </div>
                <div class="ig-item" v-if="cwDetail.dynasty"><span>Sulola</span><strong>{{ cwDetail.dynasty }}</strong>
                </div>
                <div class="ig-item" v-if="cwDetail.ruler"><span>Hukmdor</span><strong>{{ cwDetail.ruler }}</strong>
                </div>
                <div class="ig-item" v-if="cwDetail.diameter_mm">
                  <span>Diametr (mm)</span><strong>{{ cwDetail.diameter_mm }}</strong></div>
                <div class="ig-item" v-if="cwDetail.weight_g"><span>Og'irligi (g)</span><strong>{{
                    cwDetail.weight_g
                  }}</strong></div>
                <div class="ig-item" v-if="cwDetail.genre"><span>Janr</span><strong>{{ cwDetail.genre }}</strong></div>
                <div class="ig-item" v-if="cwDetail.performer"><span>Ijrochi</span><strong>{{
                    cwDetail.performer
                  }}</strong></div>
                <div class="ig-item" v-if="cwDetail.duration"><span>Davomiyligi</span><strong>{{
                    cwDetail.duration
                  }}</strong></div>
                <div class="ig-item" v-if="cwDetail.source" style="grid-column:1/-1">
                  <span>Manba</span><strong>{{ cwDetail.source }}</strong></div>
                <div class="ig-item" v-if="cwDetail.keywords" style="grid-column:1/-1">
                  <span>Kalit so‘zlar</span><strong>{{ cwDetail.keywords }}</strong></div>
              </div>
            </div>
            <div class="cw-modal-section" v-if="cwDetail.annotation">
              <div class="cw-modal-sec-title">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                     style="width:12px;height:12px">
                  <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                  <polyline points="14 2 14 8 20 8"/>
                </svg>
                Annotatsiya
              </div>
              <p class="cw-modal-annotation">{{ cwDetail.annotation }}</p>
            </div>
          </div>
          <div class="d-footer">
            <button class="dfbtn dfbtn-sec" @click="cwCloseDetail">Yopish</button>
          </div>
        </div>
      </div>
    </transition>

    <footer class="site-footer">
      <div class="footer-inner">
        <div class="footer-brand">
          <img src="../assets/gerb.webp" width="36" alt=""/>
          <div>
            <div class="footer-brand-name">Madaniy Meros Agentligi</div>
            <div class="footer-brand-sub">O‘zbekiston Respublikasi</div>
          </div>
        </div>
        <div class="footer-links">
          <router-link to="/map" class="fl-link">Interaktiv xarita</router-link>
          <a href="#objects-section" class="fl-link">Obyektlar</a>
          <a href="#museum-catalog-section" class="fl-link">Muzey katalogi</a>
          <a href="#cultural-wealth-section" class="fl-link">Xorijdagi madaniy boyliklar</a>
          <a href="#stats-section" class="fl-link">Statistika</a>
        </div>
        <div class="footer-copy">&#169; {{ new Date().getFullYear() }} madaniymeros.uz</div>
      </div>
    </footer>
  </div>
</template>
<script>
import axios from "axios";
import qs from "qs";

const API_BASE = "https://erp-api.madaniymeros.uz/api/v1";
const AUTH = "Basic " + btoa("admin:Meros2023@");
const CATALOG_API = "https://api.muzeykatalog.uz/v1/new-objects";
const CW_BASE = "https://erp-api.madaniymeros.uz/api/stats/cw";

const CW_TABS = [
  {
    key: "objects",
    label: "Moddiy buyumlar",
    shortLabel: "Buyum",
    color: "#4f8ef7",
    endpoint: CW_BASE + "/objects",
    icon: '<path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 2 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"/>',
    getTitle: i => i.name_uz || i.name_ru || i.name_en || i.title || "—",
    getPhoto: i => i.files?.find(f => f.file_type === 'photo')?.file || null,
    getDate: i => i.made_date || "",
    getMaterial: i => i.material_type || ""
  },
  {
    key: "manuscripts",
    label: "Qo‘lyozmalar",
    shortLabel: "Qo‘lyozma",
    color: "#10b981",
    endpoint: CW_BASE + "/manuscripts",
    icon: '<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/>',
    getTitle: i => i.name_uz || i.name_ru || i.name_en || i.name_ar || i.title || "—",
    getPhoto: i => i.files?.find(f => f.file_type === 'photo')?.file || null,
    getDate: i => i.written_date || i.copied_date || "",
    getMaterial: i => i.paper_type || ""
  },
  {
    key: "miniatures",
    label: "Miniatyuralar",
    shortLabel: "Miniatyura",
    color: "#a78bfa",
    endpoint: CW_BASE + "/miniatures",
    icon: '<rect x="3" y="3" width="18" height="18" rx="2"/><circle cx="8.5" cy="8.5" r="1.5"/><polyline points="21 15 16 10 5 21"/>',
    getTitle: i => i.name_uz || i.name_ru || i.name_en || i.title || "—",
    getPhoto: i => i.files?.find(f => f.file_type === 'photo')?.file || null,
    getDate: i => i.drawn_date || "",
    getMaterial: i => i.paper_type || ""
  },
  {
    key: "documents",
    label: "Hujjatlar",
    shortLabel: "Hujjat",
    color: "#f59e0b",
    endpoint: CW_BASE + "/documents",
    icon: '<path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2h-1"/>',
    getTitle: i => i.doc_type || i.title || "—",
    getPhoto: i => i.files?.find(f => f.file_type === 'photo')?.file || null,
    getDate: i => i.written_date || "",
    getMaterial: i => i.paper_type || ""
  },
  {
    key: "numismatics",
    label: "Numizmatika",
    shortLabel: "Tanga",
    color: "#eab308",
    endpoint: CW_BASE + "/numismatics",
    icon: '<circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/>',
    getTitle: i => i.coin_name || i.title || "—",
    getPhoto: i => i.files?.find(f => f.file_type === 'photo')?.file || null,
    getDate: i => i.minted_date || "",
    getMaterial: i => i.metal || ""
  },
  {
    key: "audio",
    label: "Fonoyozuvlar",
    shortLabel: "Audio",
    color: "#06b6d4",
    endpoint: CW_BASE + "/audio",
    icon: '<path d="M9 18V5l12-2v13"/><circle cx="6" cy="18" r="3"/><circle cx="18" cy="16" r="3"/>',
    getTitle: i => i.title || i.name_uz || "—",
    getPhoto: i => i.files?.find(f => f.file_type === 'photo')?.file || null,
    getDate: i => i.recorded_date || "",
    getMaterial: i => i.genre || ""
  },
  {
    key: "video",
    label: "Videoyozuvlar",
    shortLabel: "Video",
    color: "#ec4899",
    endpoint: CW_BASE + "/video",
    icon: '<polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2" ry="2"/>',
    getTitle: i => i.title || i.name_uz || "—",
    getPhoto: i => i.files?.find(f => f.file_type === 'photo')?.file || null,
    getDate: i => i.filmed_date || "",
    getMaterial: i => i.record_quality || ""
  },
];

export default {
  name: "IndexView",
  data() {
    return {
      gtOpen: false, gtSelected: "uz",
      gtLangs: [
        {code: "uz", flag: "🇺🇿", name: "O‘zbekcha", native: "O‘zbek"},
        {code: "ru", flag: "🇷🇺", name: "Ruscha", native: "Русский"},
        {code: "en", flag: "🇬🇧", name: "Inglizcha", native: "English"},
        {code: "de", flag: "🇩🇪", name: "Nemischa", native: "Deutsch"},
        {code: "fr", flag: "🇫🇷", name: "Fransuzcha", native: "Français"},
        {code: "es", flag: "🇪🇸", name: "Ispancha", native: "Español"},
        {code: "it", flag: "🇮🇹", name: "Italyancha", native: "Italiano"},
        {code: "zh-CN", flag: "🇨🇳", name: "Xitoycha", native: "中文"},
        {code: "ja", flag: "🇯🇵", name: "Yaponcha", native: "日本語"},
        {code: "ar", flag: "🇸🇦", name: "Arabcha", native: "العربية"},
        {code: "ko", flag: "🇰🇷", name: "Koreyscha", native: "한국어"},
        {code: "tr", flag: "🇹🇷", name: "Turkcha", native: "Türkçe"},
      ],
      lightbox: {open: false, photos: [], idx: 0, title: ""},
      objects: [], featuredObjects: [], totalCount: 0, totalPages: 1, currentPage: 1, perPage: 12,
      loading: false, mobileMenu: false, searchQ: "", selectedRegion: "", activeType: "",
      detailObj: null, debounceTimer: null, scrollY: 0, scrolled: false,
      heroIdx: 0, heroPrevIdx: 0,
      heroSlides: [
        {
          img: null,
          gradient: "linear-gradient(135deg,#0a1f0d,#1a472a,#0d2b19)",
          tag: "Arxitektura Merosi",
          titleSmall: "O‘zbekiston",
          titleBig: "Yodgorliklari",
          stripLabel: "Arxitektura",
          desc: "Buyuk Ipak yo‘li bo‘ylab joylashgan minglab arxitektura obidalari — mozaikalar, minoralar, ulkan masjidlar."
        },
        {
          img: null,
          gradient: "linear-gradient(135deg,#1a0f05,#5c3010,#2b1508)",
          tag: "Arxeologiya Topilmalari",
          titleSmall: "Qadimiy",
          titleBig: "Artefaktlar",
          stripLabel: "Arxeologiya",
          desc: "Miloddan avvalgi davrlarga oid sopol idishlar, tangalar va qimmatbaho buyumlar ilmiy katalogda."
        },
        {
          img: null,
          gradient: "linear-gradient(135deg,#0a0d1f,#1a2a6c,#0d1040)",
          tag: "Monumental San'at",
          titleSmall: "Tarixiy",
          titleBig: "Mozaikalar",
          stripLabel: "Monumental",
          desc: "Samarqand, Buxoro va Xivadagi noyob mozaikalar, miniatüralar va haykaltaroshlik asarlari."
        },
        {
          img: null,
          gradient: "linear-gradient(135deg,#1a0a1f,#4a1a6c,#250a40)",
          tag: "Diqqatga Sazovor",
          titleSmall: "Tabiat va",
          titleBig: "Madaniyat",
          stripLabel: "Diqqatga",
          desc: "Tabiiy parklar, qo‘riqxonalar va turistik diqqatga sazovor joylar — hammasi bir tizimda."
        },
      ],
      slideProgress: 0, slideProgressTimer: null, slideDuration: 5000,
      heroStatItems: [{label: "Jami Obyektlar", val: "0"}, {label: "Muzey Buyumlari", val: "328K+"}, {
        label: "hududlar",
        val: "14"
      }],
      statsData: [
        {
          label: "Tizimda bor obyektlar",
          num: 0,
          animated: "0",
          bg: "rgba(200,169,110,.15)",
          icon: '<path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>',
          pct: 95
        },
        {
          label: "Tizimda bor Arxitektura obyektlari",
          num: 0,
          animated: "0",
          bg: "rgba(26,71,42,.4)",
          icon: '<path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/>',
          pct: 70
        },
        {
          label: "Tizimda bor Arxeologiya obyektlari",
          num: 0,
          animated: "0",
          bg: "rgba(200,129,58,.2)",
          icon: '<circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/>',
          pct: 60
        },
        {
          label: "Tizimda bor hududlar obyektlari",
          num: 14,
          animated: "0",
          bg: "rgba(46,134,171,.2)",
          icon: '<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/>',
          pct: 100
        },
      ],
      regions: [
        {name: "Samarqand viloyati", short: "Samarqand", count: 0, color: "#c8a96e"},
        {name: "Buxora viloyati", short: "Buxoro", count: 0, color: "#c8813a"},
        {name: "Toshkent shahar", short: "Toshkent sh.", count: 0, color: "#2e86ab"},
        {name: "Navoiy viloyati", short: "Navoiy", count: 0, color: "#7b5ea7"},
        {name: "Xorazm viloyati", short: "Xorazm", count: 0, color: "#1a472a"},
        {name: "Qashqadaryo viloyati", short: "Qashqadaryo", count: 0, color: "#ef4444"},
        {name: "Surxondaryo viloyati", short: "Surxondaryo", count: 0, color: "#84cc16"},
        {name: "Toshkent viloyati", short: "Toshkent vil.", count: 0, color: "#f59e0b"},
        {name: "Fargʻona viloyati", short: "Fargʻona viloyati", count: 0, color: "#22c55e"},
        {name: "Andijon viloyati", short: "Andijon", count: 0, color: "#06b6d4"},
        {name: "Namangan viloyati", short: "Namangan", count: 0, color: "#e879f9"},
        {name: "Jizzax viloyati", short: "Jizzax", count: 0, color: "#fb923c"},
        {name: "Sirdaryo viloyati", short: "Sirdaryo", count: 0, color: "#a3e635"},
        {name: "Qoraqalpogʻiston Respublikasi", short: "Qoraqalpogʻiston Respublikasi", count: 0, color: "#60a5fa"},
      ],
      artifacts: [], artifactTotal: 0, artTotalPages: 1, artPage: 1, artPageSize: 20,
      artLoading: false, artSearch: "", artRegion: "", artMaterial: "", artDebounceTimer: null,
      artifactDetail: null, artActivePhoto: null,
      catalogItems: [], catalogTotal: 0, catTotalPages: 1, catPage: 1, catPageSize: 12,
      catLoading: false, catSearch: "", catMaterial: "", catSort: "-count", catDebounceTimer: null,
      catalogDetail: null, catActivePhoto: null,
      typeFilter: [
        {val: "", label: "Hammasi", color: "#c8a96e"},
        {val: "Arxitektura yodgorliklari", label: "Arxitektura", color: "#1a472a"},
        {val: "Arxeologiya yodgorliklari", label: "Arxeologiya", color: "#c8813a"},
        {val: "Monumental san'at yodgorliklari", label: "Monumental", color: "#7b5ea7"},
        {val: "Diqqatga sazovor joylar", label: "Diqqatga", color: "#2e86ab"},
      ],
      // ── CULTURAL WEALTH ──
      cwTabs: CW_TABS,
      cwActiveTab: "objects",
      cwItems: [], cwCounts: {}, cwTotalCount: 0, cwTotalPages: 1, cwPage: 1, cwPageSize: 12,
      cwLoading: false, cwSearch: "", cwFilterCountry: "", cwSort: "", cwDebounceTimer: null, cwDetail: null,
    };
  },
  computed: {
    maxRegionCount() {
      return Math.max(...this.regions.map(r => r.count), 1);
    },
    visiblePages() {
      return this._buildPages(this.currentPage, this.totalPages);
    },
    visibleArtPages() {
      return this._buildPages(this.artPage, this.artTotalPages);
    },
    visibleCatPages() {
      return this._buildPages(this.catPage, this.catTotalPages);
    },
    cwVisiblePages() {
      return this._buildPages(this.cwPage, this.cwTotalPages);
    },
    currentLang() {
      return this.gtLangs.find(l => l.code === this.gtSelected) || this.gtLangs[0];
    },
    cwCurrentTab() {
      return this.cwTabs.find(t => t.key === this.cwActiveTab) || this.cwTabs[0];
    },
  },
  mounted() {
    this.fetchObjects();
    this.fetchFeatured();
    this.fetchRegionStats();
    this.fetchArtifacts();
    this.fetchCatalog();
    this.cwFetch();
    this.cwLoadCounts();
    this.initParticles();
    this.startSlider();
    window.addEventListener("scroll", this.onScroll);
    window.addEventListener("keydown", this.onKeyDown);
    document.addEventListener("click", this.onGTOutsideClick);
    this.initGoogleTranslate();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
    window.removeEventListener("keydown", this.onKeyDown);
    document.removeEventListener("click", this.onGTOutsideClick);
    if (this._animFrame) cancelAnimationFrame(this._animFrame);
    this.stopSlider();
  },
  methods: {
    onKeyDown(e) {
      if (!this.lightbox.open) return;
      if (e.key === "Escape") this.closeLightbox();
      if (e.key === "ArrowRight") this.lbNext();
      if (e.key === "ArrowLeft") this.lbPrev();
    },
    initGoogleTranslate() {
      if (!document.getElementById("gt-script")) {
        window.googleTranslateElementInit = () => {
          new window.google.translate.TranslateElement({
            pageLanguage: "uz",
            includedLanguages: "uz,ru,en,de,fr,es,it,zh-CN,ja,ar,ko,tr",
            layout: window.google.translate.TranslateElement.InlineLayout.SIMPLE,
            autoDisplay: false
          }, "google_translate_element");
        };
        const s = document.createElement("script");
        s.id = "gt-script";
        s.src = "//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit";
        s.async = true;
        document.head.appendChild(s);
      }
    },
    toggleGT() {
      this.gtOpen = !this.gtOpen;
    },
    onGTOutsideClick(e) {
      if (this.$refs.gtWrap && !this.$refs.gtWrap.contains(e.target)) this.gtOpen = false;
    },
    selectGTLang(lang) {
      this.gtSelected = lang.code;
      this.gtOpen = false;
      if (lang.code === "uz") {
        this.resetGTLang();
        return;
      }
      this.applyGTLang(lang.code);
    },
    applyGTLang(langCode) {
      const sc = (n, v, d) => {
        const x = new Date();
        x.setTime(x.getTime() + d * 86400000);
        document.cookie = n + "=" + v + ";path=/;expires=" + x.toUTCString() + ";domain=" + window.location.hostname;
      };
      sc("googtrans", "/uz/" + langCode, 1);
      const tryS = (a = 0) => {
        const s = document.querySelector(".goog-te-combo");
        if (s) {
          s.value = langCode;
          s.dispatchEvent(new Event("change"));
        } else if (a < 20) setTimeout(() => tryS(a + 1), 200); else window.location.reload();
      };
      tryS();
    },
    resetGTLang() {
      document.cookie = "googtrans=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;domain=" + window.location.hostname;
      document.cookie = "googtrans=;path=/;expires=Thu, 01 Jan 1970 00:00:00 UTC;";
      const s = document.querySelector(".goog-te-combo");
      if (s) {
        s.value = "uz";
        s.dispatchEvent(new Event("change"));
      } else window.location.reload();
    },
    openLightbox(photos, idx = 0, title = "") {
      this.lightbox = {open: true, photos, idx, title};
      document.body.style.overflow = "hidden";
    },
    closeLightbox() {
      this.lightbox.open = false;
      document.body.style.overflow = "";
    },
    lbNext() {
      this.lightbox.idx = (this.lightbox.idx + 1) % this.lightbox.photos.length;
    },
    lbPrev() {
      this.lightbox.idx = (this.lightbox.idx - 1 + this.lightbox.photos.length) % this.lightbox.photos.length;
    },
    openObjGallery(obj, startIdx = 0) {
      const p = (obj.photos && obj.photos.length) ? obj.photos : [];
      if (!p.length) return;
      this.openLightbox(p, startIdx, obj.obj_name || "");
    },
    openSlideGallery(idx) {
      const s = this.heroSlides[idx];
      if (!s.img) return;
      this.openLightbox([s.img], 0, s.tag);
    },
    openArtifactGallery(a, startIdx = 0) {
      const p = this.artifactPhotos(a);
      if (!p.length) return;
      this.openLightbox(p, startIdx, a.nomi || "");
    },
    openCatalogGallery(item, startIdx = 0) {
      const p = this.catalogPhotos(item);
      if (!p.length) return;
      this.openLightbox(p, startIdx, item.title || item.fullname || "");
    },
    _buildPages(c, t) {
      const p = [];
      if (t <= 7) {
        for (let i = 1; i <= t; i++) p.push(i);
      } else {
        p.push(1);
        if (c > 3) p.push("...");
        for (let i = Math.max(2, c - 1); i <= Math.min(t - 1, c + 1); i++) p.push(i);
        if (c < t - 2) p.push("...");
        p.push(t);
      }
      return p;
    },
    onScroll() {
      this.scrollY = window.scrollY;
      this.scrolled = window.scrollY > 60;
    },
    startSlider() {
      this.slideProgress = 0;
      this.stopSlider();
      const step = 100 / (this.slideDuration / 50);
      this.slideProgressTimer = setInterval(() => {
        this.slideProgress += step;
        if (this.slideProgress >= 100) this.slideNext();
      }, 50);
    },
    stopSlider() {
      if (this.slideProgressTimer) clearInterval(this.slideProgressTimer);
    },
    slideNext() {
      this.heroPrevIdx = this.heroIdx;
      this.heroIdx = (this.heroIdx + 1) % this.heroSlides.length;
      this.slideProgress = 0;
    },
    slidePrev() {
      this.heroPrevIdx = this.heroIdx;
      this.heroIdx = (this.heroIdx - 1 + this.heroSlides.length) % this.heroSlides.length;
      this.slideProgress = 0;
    },
    goToSlide(idx) {
      if (idx === this.heroIdx) return;
      this.heroPrevIdx = this.heroIdx;
      this.heroIdx = idx;
      this.slideProgress = 0;
    },
    async fetchObjects(page = 1) {
      this.loading = true;
      try {
        const params = {page, per_page: this.perPage};
        if (this.searchQ) params.name = this.searchQ;
        if (this.selectedRegion) params.regions_name = this.selectedRegion;
        if (this.activeType) params.category = this.activeType;
        const res = await axios.get(`${API_BASE}/objects_main/`, {
          params,
          paramsSerializer: p => qs.stringify(p, {encode: true}),
          headers: {Authorization: AUTH}
        });
        const d = res.data;
        if (d && d.data) {
          this.objects = d.data;
          this.totalCount = d.total_counts || 0;
          this.totalPages = d.total_pages || 1;
          this.currentPage = d.page || page;
          this.updateStats(d.total_counts);
          this.$set(this.heroStatItems[0], "val", (d.total_counts || 0).toLocaleString() + "+");
          d.data.forEach((obj, i) => {
            if (i < this.heroSlides.length && obj.photos && obj.photos.length) {
              this.$set(this.heroSlides[i], "img", obj.photos[0]);
              this.$set(this.heroSlides[i], "allPhotos", obj.photos);
              this.$set(this.heroSlides[i], "objName", obj.obj_name || "");
            }
          });
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },
    async fetchFeatured() {
      try {
        const res = await axios.get(`${API_BASE}/objects_main/`, {
          params: {page: 1, per_page: 8},
          paramsSerializer: p => qs.stringify(p, {encode: true}),
          headers: {Authorization: AUTH}
        });
        if (res.data && res.data.data) {
          this.featuredObjects = res.data.data.filter(o => o.photos && o.photos.length);
          if (this.featuredObjects.length < 4) this.featuredObjects = res.data.data.slice(0, 4);
        }
      } catch (e) {
        console.log(e);
      }
    },
    async fetchRegionStats() {
      try {
        await Promise.all(this.regions.slice(0, 14).map(async (r) => {
          const res = await axios.get(`${API_BASE}/objects_main/`, {
            params: {
              page: 1,
              per_page: 1,
              regions_name: r.name
            }, paramsSerializer: p => qs.stringify(p, {encode: true}), headers: {Authorization: AUTH}
          });
          if (res.data) r.count = res.data.total_counts || 0;
        }));
      } catch (e) {
        console.log(e);
      }
    },
    updateStats(total) {
      const targets = [total, Math.floor(total * .38), Math.floor(total * .44), 14];
      targets.forEach((t, i) => {
        let start = 0;
        const step = t / 50;
        const timer = setInterval(() => {
          start += step;
          if (start >= t) {
            start = t;
            clearInterval(timer);
          }
          this.$set(this.statsData[i], "animated", i === 3 ? Math.floor(start).toString() : Math.floor(start).toLocaleString());
        }, 20);
      });
    },
    debounceSearch() {
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        this.currentPage = 1;
        this.fetchObjects();
      }, 500);
    },
    clearSearch() {
      this.searchQ = "";
      this.currentPage = 1;
      this.fetchObjects();
    },
    onFilterChange() {
      this.currentPage = 1;
      this.fetchObjects();
    },
    setType(val) {
      this.activeType = val;
      this.currentPage = 1;
      this.fetchObjects();
    },
    resetAll() {
      this.searchQ = "";
      this.selectedRegion = "";
      this.activeType = "";
      this.fetchObjects(1);
    },
    changePage(p) {
      if (p >= 1 && p <= this.totalPages) this.fetchObjects(p);
    },
    openDetail(obj) {
      this.detailObj = obj;
      document.body.style.overflow = "hidden";
    },
    closeDetail() {
      this.detailObj = null;
      document.body.style.overflow = "";
    },
    goToMap(obj) {
      try {
        localStorage.setItem("mapFlyTo", JSON.stringify({id: obj.id, lat: obj.latitude, lng: obj.longitude}));
      } catch (e) {
        console.log(e);
      }
      this.$router.push("/map");
    },
    goRegion(name) {
      this.selectedRegion = name;
      this.$nextTick(() => {
        document.getElementById("objects-section").scrollIntoView({behavior: "smooth"});
        this.onFilterChange();
      });
    },
    imgErr(e) {
      e.target.style.display = "none";
    },
    typeColor(t) {
      return {
        "Arxeologiya yodgorliklari": "#c8813a",
        "Monumental san\u2019at yodgorliklari": "#7b5ea7",
        "Diqqatga sazovor joylar": "#2e86ab",
        "Arxitektura yodgorliklari": "#1a472a"
      }[t] || "#5a6a75";
    },
    typeGradient(t) {
      return {
        "Arxeologiya yodgorliklari": "linear-gradient(135deg,#c8813a,#8b5e2c)",
        "Monumental san\u2019at yodgorliklari": "linear-gradient(135deg,#7b5ea7,#4a3570)",
        "Diqqatga sazovor joylar": "linear-gradient(135deg,#2e86ab,#1a5472)",
        "Arxitektura yodgorliklari": "linear-gradient(135deg,#1a472a,#0d2b19)"
      }[t] || "linear-gradient(135deg,#5a6a75,#3a4a55)";
    },
    shortType(t) {
      return {
        "Arxeologiya yodgorliklari": "Arxeo",
        "Monumental san\u2019at yodgorliklari": "Monum",
        "Diqqatga sazovor joylar": "Diqqat",
        "Arxitektura yodgorliklari": "Arxitek"
      }[t] || (t ? t.slice(0, 7) : "\u2014");
    },
    async fetchArtifacts(page = 1) {
      this.artLoading = true;
      try {
        const params = {page, page_size: this.artPageSize};
        if (this.artRegion) params.viloyat = this.artRegion;
        if (this.artMaterial) params.materiali = this.artMaterial;
        if (this.artSearch) params.search = this.artSearch;
        const res = await axios.get(`${API_BASE}/approved-artifacts/`, {
          params,
          paramsSerializer: p => qs.stringify(p, {encode: true}),
          headers: {Authorization: AUTH}
        });
        const d = res.data;
        if (d) {
          this.artifacts = d.results || [];
          this.artifactTotal = d.count || 0;
          this.artTotalPages = Math.ceil((d.count || 0) / this.artPageSize) || 1;
          this.artPage = page;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.artLoading = false;
      }
    },
    debounceArtSearch() {
      clearTimeout(this.artDebounceTimer);
      this.artDebounceTimer = setTimeout(() => {
        this.artPage = 1;
        this.fetchArtifacts();
      }, 500);
    },
    clearArtSearch() {
      this.artSearch = "";
      this.artPage = 1;
      this.fetchArtifacts();
    },
    resetArtFilters() {
      this.artSearch = "";
      this.artRegion = "";
      this.artMaterial = "";
      this.fetchArtifacts(1);
    },
    changeArtPage(p) {
      if (p >= 1 && p <= this.artTotalPages) this.fetchArtifacts(p);
    },
    openArtifact(a) {
      this.artifactDetail = a;
      const p = this.artifactPhotos(a);
      this.artActivePhoto = p.length ? p[0] : null;
      document.body.style.overflow = "hidden";
    },
    closeArtifact() {
      this.artifactDetail = null;
      document.body.style.overflow = "";
    },
    artifactPhotos(a) {
      return [a.tasvir_1, a.tasvir_2, a.tasvir_3, a.tasvir_4, a.tasvir_5, a.tasvir_6, a.tasvir_7, a.tasvir_8].filter(Boolean);
    },
    async fetchCatalog(page = 1) {
      this.catLoading = true;
      try {
        const params = {_l: "uz", include: "image,museum", "per-page": this.catPageSize, sort: this.catSort, page};
        if (this.catSearch) params.search = this.catSearch;
        if (this.catMaterial) params.material = this.catMaterial;
        const res = await axios.get(CATALOG_API, {params, paramsSerializer: p => qs.stringify(p, {encode: true})});
        const d = res.data;
        if (d) {
          this.catalogItems = d.data || [];
          this.catalogTotal = d._meta ? d._meta.totalCount : 0;
          this.catTotalPages = d._meta ? d._meta.pageCount : 1;
          this.catPage = page;
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.catLoading = false;
      }
    },
    debounceCatSearch() {
      clearTimeout(this.catDebounceTimer);
      this.catDebounceTimer = setTimeout(() => {
        this.catPage = 1;
        this.fetchCatalog();
      }, 500);
    },
    clearCatSearch() {
      this.catSearch = "";
      this.catPage = 1;
      this.fetchCatalog();
    },
    resetCatFilters() {
      this.catSearch = "";
      this.catMaterial = "";
      this.catSort = "-count";
      this.fetchCatalog(1);
    },
    changeCatPage(p) {
      if (p >= 1 && p <= this.catTotalPages) {
        this.fetchCatalog(p);
        document.getElementById("museum-catalog-section").scrollIntoView({behavior: "smooth"});
      }
    },
    openCatalogItem(item) {
      this.catalogDetail = item;
      const p = this.catalogPhotos(item);
      this.catActivePhoto = p.length ? p[0] : null;
      document.body.style.overflow = "hidden";
    },
    closeCatalogItem() {
      this.catalogDetail = null;
      document.body.style.overflow = "";
    },
    catalogPhotos(item) {
      if (!item.image || !item.image.length) return [];
      return item.image.map(img => img.thumbnails && img.thumbnails.normal ? img.thumbnails.normal.src : img.link).filter(Boolean);
    },
    // ── CULTURAL WEALTH ──
    async cwLoadCounts() {
      await Promise.all(this.cwTabs.map(async (tab) => {
        try {
          const res = await axios.get(`${tab.endpoint}/?page_size=1`, {headers: {Authorization: AUTH}});
          const cnt = res.data.count || (Array.isArray(res.data) ? res.data.length : 0);
          this.$set(this.cwCounts, tab.key, cnt);
        } catch (e) {
          this.$set(this.cwCounts, tab.key, 0);
        }
      }));
    },
    async cwFetch(page = 1) {
      this.cwLoading = true;
      try {
        let url = `${this.cwCurrentTab.endpoint}/?page=${page}&page_size=${this.cwPageSize}`;
        if (this.cwSearch) url += `&search=${encodeURIComponent(this.cwSearch)}`;
        if (this.cwFilterCountry) url += `&country=${encodeURIComponent(this.cwFilterCountry)}`;
        if (this.cwSort) url += `&ordering=${encodeURIComponent(this.cwSort)}`;
        const res = await axios.get(url, {headers: {Authorization: AUTH}});
        const d = res.data;
        this.cwItems = d.results || (Array.isArray(d) ? d : []);
        this.cwTotalCount = d.count || this.cwItems.length;
        this.cwTotalPages = Math.ceil(this.cwTotalCount / this.cwPageSize) || 1;
        this.cwPage = page;
      } catch (e) {
        console.error("cwFetch:", e);
        this.cwItems = [];
      } finally {
        this.cwLoading = false;
      }
    },
    cwSwitchTab(key) {
      this.cwActiveTab = key;
      this.cwSearch = "";
      this.cwFilterCountry = "";
      this.cwSort = "";
      this.cwPage = 1;
      this.cwFetch();
    },
    debounceCwSearch() {
      clearTimeout(this.cwDebounceTimer);
      this.cwDebounceTimer = setTimeout(() => {
        this.cwPage = 1;
        this.cwFetch();
      }, 500);
    },
    cwClearSearch() {
      this.cwSearch = "";
      this.cwPage = 1;
      this.cwFetch();
    },
    cwResetFilters() {
      this.cwSearch = "";
      this.cwFilterCountry = "";
      this.cwSort = "";
      this.cwPage = 1;
      this.cwFetch();
    },
    cwChangePage(p) {
      if (p >= 1 && p <= this.cwTotalPages) {
        this.cwFetch(p);
        document.getElementById("cultural-wealth-section").scrollIntoView({behavior: "smooth"});
      }
    },
    cwOpenDetail(item) {
      this.cwDetail = item;
      document.body.style.overflow = "hidden";
    },
    cwCloseDetail() {
      this.cwDetail = null;
      document.body.style.overflow = "";
    },
    cwItemTitle(item) {
      return this.cwCurrentTab.getTitle(item);
    },
    cwItemPhoto(item) {
      return this.cwCurrentTab.getPhoto(item);
    },
    cwItemDate(item) {
      return this.cwCurrentTab.getDate(item);
    },
    cwItemMaterial(item) {
      return this.cwCurrentTab.getMaterial(item);
    },
    initParticles() {
      const canvas = this.$refs.particleCanvas;
      if (!canvas) return;
      const ctx = canvas.getContext("2d");
      let W, H, particles = [];
      const resize = () => {
        W = canvas.width = window.innerWidth;
        H = canvas.height = window.innerHeight * 1.5;
      };
      resize();
      window.addEventListener("resize", resize);
      for (let i = 0; i < 55; i++) particles.push({
        x: Math.random() * W,
        y: Math.random() * H,
        r: Math.random() * 1.5 + .3,
        vx: (Math.random() - .5) * .25,
        vy: (Math.random() - .5) * .25,
        a: Math.random() * .5 + .1
      });
      const draw = () => {
        ctx.clearRect(0, 0, W, H);
        particles.forEach(p => {
          ctx.beginPath();
          ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(200,169,110,${p.a})`;
          ctx.fill();
          p.x += p.vx;
          p.y += p.vy;
          if (p.x < 0 || p.x > W) p.vx *= -1;
          if (p.y < 0 || p.y > H) p.vy *= -1;
        });
        this._animFrame = requestAnimationFrame(draw);
      };
      draw();
    },
  },
};
</script>
<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,400;0,600;0,700;1,400&family=Crimson+Pro:wght@300;400;500;600&display=swap');

*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

.index-root {
  font-family: 'Crimson Pro', Georgia, serif;
  background: #080f09;
  color: #f0ebe0;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

.particle-canvas {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 0;
  opacity: .6;
}

/* LIGHTBOX */
.lightbox-ov {
  position: fixed;
  inset: 0;
  z-index: 99999;
  background: rgba(0, 0, 0, .96);
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(16px);
}

.lightbox-box {
  position: relative;
  width: 100%;
  max-width: 1100px;
  max-height: 94vh;
  display: flex;
  flex-direction: column;
  padding: 0 1rem;
}

.lb-close {
  position: fixed;
  top: 1.2rem;
  right: 1.2rem;
  z-index: 10;
  width: 40px;
  height: 40px;
  background: rgba(255, 255, 255, .08);
  border: 1px solid rgba(255, 255, 255, .15);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .2s;
  color: white;
}

.lb-close:hover {
  background: rgba(200, 169, 110, .25);
  border-color: rgba(200, 169, 110, .5);
}

.lb-close svg {
  width: 16px;
  height: 16px;
  stroke: white;
}

.lb-nav {
  position: fixed;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  width: 48px;
  height: 48px;
  background: rgba(255, 255, 255, .07);
  border: 1px solid rgba(200, 169, 110, .2);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .2s;
}

.lb-nav:hover {
  background: rgba(200, 169, 110, .2);
  border-color: rgba(200, 169, 110, .5);
}

.lb-nav svg {
  width: 18px;
  height: 18px;
  stroke: #c8a96e;
}

.lb-prev {
  left: 1.5rem;
}

.lb-next {
  right: 1.5rem;
}

.lb-main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 0;
}

.lb-photo {
  max-width: 100%;
  max-height: 75vh;
  object-fit: contain;
  border-radius: 8px;
  box-shadow: 0 32px 80px rgba(0, 0, 0, .8);
}

.lb-caption {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: .8rem 0 .5rem;
  width: 100%;
  max-width: 800px;
}

.lb-title {
  font-family: 'Playfair Display', serif;
  font-size: 1rem;
  color: #e8e0d0;
}

.lb-counter {
  font-size: .75rem;
  color: rgba(200, 169, 110, .6);
}

.lb-thumbs {
  display: flex;
  gap: .4rem;
  justify-content: center;
  overflow-x: auto;
  padding: .4rem 0;
  scrollbar-width: thin;
}

.lb-thumb {
  width: 64px;
  height: 48px;
  border-radius: 5px;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  transition: all .2s;
  border: 2px solid rgba(200, 169, 110, .1);
  opacity: .5;
}

.lb-thumb:hover {
  opacity: .8;
}

.lb-thumb.active {
  opacity: 1;
  border-color: #c8a96e;
  transform: scale(1.05);
}

.lb-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.lb-fade-enter-active, .lb-fade-leave-active {
  transition: opacity .2s;
}

.lb-fade-enter, .lb-fade-leave-to {
  opacity: 0;
}

.lb-img-enter-active, .lb-img-leave-active {
  transition: all .25s ease;
}

.lb-img-enter {
  opacity: 0;
  transform: scale(.97);
}

.lb-img-leave-to {
  opacity: 0;
  transform: scale(1.02);
}

/* HEADER */
.site-header {
  position: sticky;
  top: 0;
  z-index: 1000;
  background: rgba(8, 15, 9, .75);
  border-bottom: 1px solid rgba(200, 169, 110, .1);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  transition: all .35s ease;
}

.site-header.scrolled {
  background: rgba(8, 15, 9, .97);
  border-bottom-color: rgba(200, 169, 110, .22);
  box-shadow: 0 4px 32px rgba(0, 0, 0, .45);
}

.header-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  height: 68px;
  display: flex;
  align-items: center;
  gap: 2rem;
}

.brand {
  display: flex;
  align-items: center;
  gap: .85rem;
  flex-shrink: 0;
}

.brand-emblem {
  width: 46px;
  height: 46px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(200, 169, 110, .07);
  border: 1px solid rgba(200, 169, 110, .18);
  border-radius: 10px;
}

.brand-text {
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.brand-sup {
  font-size: .56rem;
  color: #6a7f6e;
  text-transform: uppercase;
  letter-spacing: .12em;
}

.brand-main {
  font-family: 'Playfair Display', serif;
  font-size: .92rem;
  font-weight: 700;
  color: #c8a96e;
  line-height: 1.1;
}

.main-nav {
  display: flex;
  align-items: center;
  gap: .15rem;
  margin-left: auto;
}

.nav-link {
  font-family: 'Crimson Pro', serif;
  font-size: .88rem;
  color: #9aaa9e;
  text-decoration: none;
  padding: .45rem .85rem;
  border-radius: 7px;
  transition: all .2s;
  border: 1px solid transparent;
  white-space: nowrap;
}

.nav-link:hover {
  color: #d4b97a;
  background: rgba(200, 169, 110, .07);
}

.nav-link.active {
  color: #c8a96e;
}

.map-nav-link {
  display: flex;
  align-items: center;
  gap: .45rem;
  background: rgba(26, 71, 42, .55);
  border: 1px solid rgba(200, 169, 110, .28) !important;
  color: #c8a96e !important;
  font-weight: 600;
  padding: .44rem 1rem !important;
  margin-left: .35rem;
}

.map-nav-link:hover {
  background: rgba(26, 71, 42, .85) !important;
}

.map-link-icon svg {
  width: 13px;
  height: 13px;
}

.new-badge {
  font-size: .5rem;
  background: #c8a96e;
  color: #080f09;
  padding: .07rem .32rem;
  border-radius: 3px;
  font-weight: 800;
  letter-spacing: .06em;
}

.mobile-menu-btn {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: 1px solid rgba(200, 169, 110, .15);
  cursor: pointer;
  padding: .45rem .5rem;
  border-radius: 7px;
  margin-left: auto;
}

.mobile-menu-btn span {
  display: block;
  width: 20px;
  height: 1.5px;
  background: #c8a96e;
  border-radius: 2px;
  transition: all .3s;
}

.mobile-menu-btn.open span:nth-child(1) {
  transform: translateY(6.5px) rotate(45deg);
}

.mobile-menu-btn.open span:nth-child(2) {
  opacity: 0;
}

.mobile-menu-btn.open span:nth-child(3) {
  transform: translateY(-6.5px) rotate(-45deg);
}

.mobile-nav {
  background: rgba(8, 15, 9, .98);
  border-top: 1px solid rgba(200, 169, 110, .1);
  padding: .6rem 1.5rem 1.2rem;
  display: flex;
  flex-direction: column;
  gap: .2rem;
}

.mnav-link {
  font-family: 'Crimson Pro', serif;
  font-size: 1rem;
  color: #9aaa9e;
  text-decoration: none;
  padding: .65rem .5rem;
  border-bottom: 1px solid rgba(200, 169, 110, .06);
}

.mnav-link:hover {
  color: #c8a96e;
}

.mnav-map {
  color: #c8a96e !important;
  font-weight: 600;
}

.mnav-vr {
  color: #7dd3fc !important;
  font-weight: 600;
}

.vr-btn {
  position: relative;
  display: inline-flex;
  align-items: center;
  gap: .5rem;
  padding: .3rem .7rem .3rem .4rem;
  border-radius: 9px;
  text-decoration: none;
  border: 1px solid rgba(125, 211, 252, .28);
  background: rgba(14, 40, 60, .55);
  transition: all .25s;
  flex-shrink: 0;
  overflow: hidden;
  margin-left: .3rem;
}

.vr-btn:hover {
  background: rgba(14, 40, 60, .85);
  border-color: rgba(125, 211, 252, .55);
  transform: translateY(-1px);
}

.vr-btn-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  background: rgba(125, 211, 252, .12);
  border-radius: 6px;
  flex-shrink: 0;
}

.vr-btn-icon svg {
  width: 15px;
  height: 15px;
  stroke: #7dd3fc;
  fill: none;
}

.vr-btn-text {
  display: flex;
  flex-direction: column;
  line-height: 1;
  gap: 1px;
}

.vr-btn-top {
  font-family: 'Playfair Display', serif;
  font-size: .82rem;
  font-weight: 700;
  color: #7dd3fc;
}

.vr-btn-bottom {
  font-family: 'Crimson Pro', serif;
  font-size: .62rem;
  color: rgba(125, 211, 252, .6);
  text-transform: uppercase;
}

.vr-pulse {
  position: absolute;
  top: 6px;
  right: 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: #7dd3fc;
}

.vr-pulse::before {
  content: '';
  position: absolute;
  inset: -3px;
  border-radius: 50%;
  border: 1.5px solid rgba(125, 211, 252, .5);
  animation: vr-ring 1.8s ease-out infinite;
}

@keyframes vr-ring {
  0% {
    transform: scale(1);
    opacity: .8;
  }
  100% {
    transform: scale(2.4);
    opacity: 0;
  }
}

.menu-drop-enter-active, .menu-drop-leave-active {
  transition: all .25s;
}

.menu-drop-enter, .menu-drop-leave-to {
  opacity: 0;
  transform: translateY(-8px);
}

.text_decaration {
  text-decoration: none;
}

/* GOOGLE TRANSLATE */
.gt-wrap {
  position: relative;
  z-index: 2001;
  margin-left: .5rem;
}

.gt-trigger {
  display: flex;
  align-items: center;
  gap: .4rem;
  background: rgba(200, 169, 110, .07);
  border: 1px solid rgba(200, 169, 110, .2);
  border-radius: 9px;
  padding: .38rem .85rem;
  cursor: pointer;
  transition: all .22s;
  color: #c8a96e;
  font-family: 'Crimson Pro', Georgia, serif;
  font-size: .85rem;
  font-weight: 500;
  white-space: nowrap;
}

.gt-trigger:hover, .gt-trigger.active {
  background: rgba(200, 169, 110, .14);
  border-color: rgba(200, 169, 110, .42);
}

.gtl-flag-sm {
  font-size: .95rem;
  line-height: 1;
  flex-shrink: 0;
}

.gt-label {
  font-size: .83rem;
  font-weight: 600;
}

.gt-caret svg {
  width: 12px;
  height: 12px;
  stroke: rgba(200, 169, 110, .6);
  transition: transform .22s;
}

.gt-caret.flipped svg {
  transform: rotate(180deg);
}

.gt-panel {
  position: absolute;
  top: calc(100% + 8px);
  right: 0;
  width: 252px;
  background: rgba(9, 16, 11, .98);
  border: 1px solid rgba(200, 169, 110, .2);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 22px 55px rgba(0, 0, 0, .7);
  backdrop-filter: blur(24px);
}

.gt-panel-head {
  padding: .7rem 1rem .55rem;
  font-size: .58rem;
  text-transform: uppercase;
  letter-spacing: .14em;
  color: rgba(200, 169, 110, .45);
  border-bottom: 1px solid rgba(200, 169, 110, .08);
}

.gt-langs {
  max-height: 316px;
  overflow-y: auto;
  scrollbar-width: thin;
}

.gt-lang-item {
  width: 100%;
  display: flex;
  align-items: center;
  gap: .55rem;
  padding: .52rem 1rem;
  background: transparent;
  border: none;
  cursor: pointer;
  transition: background .16s;
  font-family: 'Crimson Pro', Georgia, serif;
  text-align: left;
}

.gt-lang-item:hover {
  background: rgba(200, 169, 110, .07);
}

.gt-lang-item.active {
  background: rgba(200, 169, 110, .1);
}

.gtl-flag {
  font-size: .95rem;
  flex-shrink: 0;
}

.gtl-name {
  font-size: .82rem;
  color: #f0ebe0;
  flex: 1;
}

.gtl-native {
  font-size: .68rem;
  color: rgba(200, 169, 110, .45);
}

.gtl-check {
  margin-left: auto;
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.gtl-check svg {
  width: 12px;
  height: 12px;
  stroke: #c8a96e;
  fill: none;
}

.gt-element-host {
  display: none !important;
  height: 0;
  overflow: hidden;
}

.gt-drop-enter-active, .gt-drop-leave-active {
  transition: all .22s cubic-bezier(.4, 0, .2, 1);
}

.gt-drop-enter, .gt-drop-leave-to {
  opacity: 0;
  transform: translateY(-7px) scale(.97);
}

:global(.skiptranslate) {
  display: none !important;
}

:global(.goog-te-banner-frame) {
  display: none !important;
}

:global(body) {
  top: 0 !important;
}

.mnav-translate {
  padding: .75rem .5rem .5rem;
  border-top: 1px solid rgba(200, 169, 110, .08);
  margin-top: .2rem;
}

.mnt-label {
  display: flex;
  align-items: center;
  gap: .4rem;
  font-size: .62rem;
  color: rgba(200, 169, 110, .5);
  text-transform: uppercase;
  letter-spacing: .1em;
  margin-bottom: .5rem;
}

.mnt-langs {
  display: flex;
  flex-wrap: wrap;
  gap: .35rem;
}

.mnt-btn {
  display: flex;
  align-items: center;
  gap: .28rem;
  padding: .3rem .65rem;
  background: rgba(200, 169, 110, .06);
  border: 1px solid rgba(200, 169, 110, .12);
  border-radius: 6px;
  color: #9aaa9e;
  font-size: .75rem;
  cursor: pointer;
  transition: all .18s;
}

.mnt-btn:hover {
  background: rgba(200, 169, 110, .12);
  color: #c8a96e;
}

.mnt-btn.active {
  background: rgba(200, 169, 110, .15);
  border-color: rgba(200, 169, 110, .35);
  color: #c8a96e;
}

/* HERO */
.hero-section {
  position: relative;
  z-index: 1;
}

.hero-track {
  position: relative;
  width: 100%;
  height: 100vh;
  min-height: 650px;
  overflow: hidden;
  display: flex;
  align-items: stretch;
}

.hero-slide {
  position: absolute;
  inset: 0;
  opacity: 0;
  transition: opacity 1.4s cubic-bezier(.4, 0, .2, 1);
  z-index: 0;
}

.hero-slide.active {
  opacity: 1;
  z-index: 1;
}

.slide-bg {
  position: absolute;
  inset: 0;
  background-size: cover;
  background-position: center;
  transform: scale(1.06);
  transition: transform 7s cubic-bezier(.25, 0, .1, 1);
}

.hero-slide.active .slide-bg {
  transform: scale(1);
}

.slide-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(105deg, rgba(8, 15, 9, .95) 0%, rgba(8, 15, 9, .75) 45%, rgba(8, 15, 9, .4) 100%);
}

.slide-noise {
  position: absolute;
  inset: 0;
  z-index: 1;
  opacity: .04;
  background-image: url("data:image/svg+xml,%3Csvg viewBox='0 0 200 200' xmlns='http://www.w3.org/2000/svg'%3E%3Cfilter id='n'%3E%3CfeTurbulence type='fractalNoise' baseFrequency='0.9' numOctaves='4'/%3E%3C/filter%3E%3Crect width='100%25' height='100%25' filter='url(%23n)'/%3E%3C/svg%3E");
  background-size: 150px 150px;
}

.slide-photo-btn {
  position: absolute;
  top: 1rem;
  right: 1rem;
  z-index: 8;
  width: 38px;
  height: 38px;
  background: rgba(0, 0, 0, .5);
  border: 1px solid rgba(200, 169, 110, .3);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  opacity: .6;
  transition: opacity .3s;
}

.hero-slide.active:hover .slide-photo-btn {
  opacity: 1;
}

.slide-photo-btn svg {
  width: 15px;
  height: 15px;
  stroke: #c8a96e;
  fill: none;
}

.hero-grid-lines {
  position: absolute;
  inset: 0;
  z-index: 2;
  pointer-events: none;
}

.hgl {
  position: absolute;
  background: rgba(200, 169, 110, .04);
}

.hgl-v1 {
  left: 33.3%;
  top: 0;
  bottom: 0;
  width: 1px;
}

.hgl-v2 {
  left: 66.6%;
  top: 0;
  bottom: 0;
  width: 1px;
}

.hgl-h1 {
  top: 50%;
  left: 0;
  right: 0;
  height: 1px;
}

.hero-stage {
  position: relative;
  z-index: 5;
  width: 100%;
  display: flex;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  padding-bottom: 100px;
}

.hero-left {
  flex: 1;
  max-width: 600px;
}

.hero-eyebrow {
  display: flex;
  align-items: center;
  gap: .75rem;
  margin-bottom: 1.8rem;
}

.eyebrow-line {
  display: block;
  width: 32px;
  height: 1.5px;
  background: #c8a96e;
  flex-shrink: 0;
}

.eyebrow-text {
  font-size: .68rem;
  color: #c8a96e;
  text-transform: uppercase;
  letter-spacing: .2em;
  font-weight: 600;
}

.hero-title {
  display: flex;
  flex-direction: column;
  gap: .1rem;
  margin-bottom: 1.5rem;
}

.ht-small {
  font-family: 'Playfair Display', serif;
  font-size: clamp(2rem, 4vw, 3.5rem);
  font-weight: 400;
  color: rgba(240, 235, 224, .6);
  line-height: 1;
}

.ht-big {
  font-family: 'Playfair Display', serif;
  font-size: clamp(3.8rem, 8vw, 7rem);
  font-weight: 700;
  line-height: .9;
  background: linear-gradient(135deg, #f0ebe0 0%, #c8a96e 60%, #a07040 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.hero-desc {
  font-size: 1.05rem;
  color: #7a8a7e;
  line-height: 1.75;
  margin-bottom: 2.5rem;
  font-weight: 300;
  max-width: 480px;
}

.hero-actions {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
}

.btn-ghost {
  display: inline-flex;
  align-items: center;
  gap: .45rem;
  background: transparent;
  color: #9aaa9e;
  font-family: 'Crimson Pro', serif;
  font-size: 1rem;
  font-weight: 500;
  padding: .85rem 1.6rem;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid rgba(200, 169, 110, .14);
  transition: all .25s;
}

.btn-ghost svg {
  width: 14px;
  height: 14px;
}

.btn-ghost:hover {
  color: #c8a96e;
  border-color: rgba(200, 169, 110, .38);
}

.hero-right {
  display: flex;
  align-items: center;
  gap: 2rem;
  flex-shrink: 0;
}

.slide-strip {
  display: flex;
  flex-direction: column;
  gap: 0;
  border-left: 1px solid rgba(200, 169, 110, .12);
}

.strip-item {
  position: relative;
  display: flex;
  align-items: center;
  gap: .65rem;
  padding: .6rem 1rem;
  cursor: pointer;
  transition: all .25s;
  overflow: hidden;
}

.strip-item::before {
  content: '';
  position: absolute;
  left: -1px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: #c8a96e;
  transform: scaleY(0);
  transition: transform .3s;
}

.strip-item.active::before {
  transform: scaleY(1);
}

.strip-item.active {
  background: rgba(200, 169, 110, .05);
}

.strip-item:hover {
  background: rgba(200, 169, 110, .04);
}

.strip-thumb {
  width: 52px;
  height: 38px;
  border-radius: 5px;
  overflow: hidden;
  flex-shrink: 0;
  border: 1px solid rgba(200, 169, 110, .1);
}

.strip-item.active .strip-thumb {
  border-color: rgba(200, 169, 110, .4);
}

.strip-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.strip-thumb-grad {
  width: 52px;
  height: 38px;
  border-radius: 5px;
}

.strip-info {
  display: flex;
  flex-direction: column;
  gap: .1rem;
}

.strip-num {
  font-family: 'Playfair Display', serif;
  font-size: .6rem;
  color: rgba(200, 169, 110, .4);
}

.strip-item.active .strip-num {
  color: #c8a96e;
}

.strip-label {
  font-size: .7rem;
  color: #4a5e4e;
  white-space: nowrap;
}

.strip-item.active .strip-label {
  color: #9aaa9e;
}

.strip-progress {
  position: absolute;
  left: -1px;
  bottom: 0;
  width: 2px;
  background: rgba(200, 169, 110, .2);
  top: 0;
  overflow: hidden;
}

.strip-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: #c8a96e;
  transition: height .05s linear;
}

.hero-card {
  width: 240px;
  background: rgba(12, 22, 14, .92);
  border: 1px solid rgba(200, 169, 110, .18);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 24px 60px rgba(0, 0, 0, .55);
  transition: transform .25s;
}

.hero-card:hover {
  transform: translateY(-3px);
}

.hc-image {
  height: 145px;
  overflow: hidden;
  position: relative;
}

.hc-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform .4s;
}

.hero-card:hover .hc-image img {
  transform: scale(1.05);
}

.hc-noimg {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.hc-noimg svg {
  width: 40px;
  height: 40px;
}

.hc-zoom-hint {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity .25s;
}

.hero-card:hover .hc-zoom-hint {
  opacity: 1;
}

.hc-zoom-hint svg {
  width: 22px;
  height: 22px;
  stroke: white;
  fill: none;
}

.hc-body {
  padding: .8rem .9rem;
}

.hc-badge {
  display: inline-block;
  font-size: .5rem;
  font-weight: 700;
  text-transform: uppercase;
  color: white;
  padding: .1rem .38rem;
  border-radius: 3px;
  margin-bottom: .35rem;
}

.hc-name {
  font-family: 'Playfair Display', serif;
  font-size: .82rem;
  font-weight: 600;
  color: #e8e0d0;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  margin-bottom: .3rem;
}

.hc-loc {
  display: flex;
  align-items: center;
  gap: .25rem;
  font-size: .68rem;
  color: #5a6a6e;
}

.hc-loc svg {
  width: 10px;
  height: 10px;
  fill: none;
  flex-shrink: 0;
}

.hero-stats-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 6;
  display: flex;
  align-items: stretch;
  background: rgba(8, 15, 9, .88);
  backdrop-filter: blur(16px);
  border-top: 1px solid rgba(200, 169, 110, .1);
  height: 72px;
}

.hsb-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 2.5rem;
  border-right: 1px solid rgba(200, 169, 110, .07);
  min-width: 140px;
}

.hsb-num {
  font-family: 'Playfair Display', serif;
  font-size: 1.4rem;
  font-weight: 700;
  color: #c8a96e;
  line-height: 1;
}

.hsb-label {
  font-size: .6rem;
  color: #4a5e4e;
  text-transform: uppercase;
  letter-spacing: .1em;
  margin-top: .18rem;
}

.hsb-sep {
  flex: 1;
}

.slider-controls-inline {
  display: flex;
  align-items: center;
  gap: .75rem;
  padding: 0 2rem;
  border-left: 1px solid rgba(200, 169, 110, .07);
}

.sc-btn {
  width: 34px;
  height: 34px;
  background: rgba(255, 255, 255, .06);
  border: 1px solid rgba(200, 169, 110, .2);
  border-radius: 50%;
  color: #c8a96e;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .2s;
}

.sc-btn:hover {
  background: rgba(200, 169, 110, .15);
}

.sc-btn svg {
  width: 13px;
  height: 13px;
}

.sc-count {
  font-family: 'Playfair Display', serif;
  font-size: .78rem;
  color: #4a5e4e;
  min-width: 50px;
  text-align: center;
}

.hero-progress-line {
  position: absolute;
  bottom: 72px;
  left: 0;
  right: 0;
  z-index: 7;
  height: 2px;
  background: rgba(200, 169, 110, .08);
}

.hpl-fill {
  height: 100%;
  background: linear-gradient(90deg, #c8a96e, #e8c885);
  transition: width .05s linear;
}

.slide-up-enter-active {
  transition: all .6s cubic-bezier(.25, .1, .25, 1);
}

.slide-up-leave-active {
  transition: all .3s ease;
}

.slide-up-enter {
  opacity: 0;
  transform: translateY(28px);
}

.slide-up-leave-to {
  opacity: 0;
  transform: translateY(-12px);
}

.card-pop-enter-active {
  transition: all .5s cubic-bezier(.34, 1.56, .64, 1);
}

.card-pop-leave-active {
  transition: all .3s ease;
}

.card-pop-enter {
  opacity: 0;
  transform: translateY(20px) scale(.95);
}

.card-pop-leave-to {
  opacity: 0;
  transform: scale(.92);
}

/* STATS */
.stats-section {
  position: relative;
  z-index: 2;
  background: rgba(255, 255, 255, .02);
  border-top: 1px solid rgba(200, 169, 110, .07);
  border-bottom: 1px solid rgba(200, 169, 110, .07);
}

.stats-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 2rem;
  display: grid;
  grid-template-columns:repeat(4, 1fr);
  gap: 1px;
}

.stat-card {
  position: relative;
  overflow: hidden;
  padding: 1.8rem 2rem;
  display: flex;
  align-items: center;
  gap: 1.2rem;
}

.stat-card::after {
  content: '';
  position: absolute;
  right: 0;
  top: 20%;
  bottom: 20%;
  width: 1px;
  background: rgba(200, 169, 110, .1);
}

.stat-card:last-child::after {
  display: none;
}

.sc-icon {
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.sc-icon svg {
  width: 20px;
  height: 20px;
  stroke: #c8a96e;
  fill: none;
}

.sc-num {
  font-family: 'Playfair Display', serif;
  font-size: 2rem;
  font-weight: 700;
  color: #f0ebe0;
  line-height: 1;
}

.sc-label {
  font-size: .72rem;
  color: #6a7a6e;
  margin-top: .2rem;
}

.sc-bar {
  position: absolute;
  bottom: 0;
  left: 0;
  height: 2px;
  transition: width 1.5s ease;
  opacity: .6;
}

/* MAP CTA */
.map-cta-section {
  position: relative;
  z-index: 2;
  padding: 5rem 2rem;
  overflow: hidden;
}

.map-cta-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 70% 50%, rgba(26, 71, 42, .28), transparent 60%);
  pointer-events: none;
}

.mcs-inner {
  max-width: 1400px;
  margin: 0 auto;
  display: grid;
  grid-template-columns:1fr 1fr;
  gap: 4rem;
  align-items: center;
}

.mcs-tag {
  display: inline-flex;
  align-items: center;
  gap: .45rem;
  font-size: .68rem;
  color: #c8a96e;
  text-transform: uppercase;
  letter-spacing: .13em;
  margin-bottom: 1.25rem;
}

.mcs-tag svg {
  width: 13px;
  height: 13px;
  fill: none;
}

.mcs-title {
  font-family: 'Playfair Display', serif;
  font-size: clamp(2rem, 3.5vw, 3rem);
  font-weight: 700;
  line-height: 1.12;
  margin-bottom: 1.2rem;
}

.mcs-title em {
  color: #c8a96e;
  font-style: italic;
}

.mcs-desc {
  font-size: 1rem;
  color: #9aaa9e;
  line-height: 1.75;
  margin-bottom: 1.8rem;
  font-weight: 300;
}

.mcs-features {
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: .55rem;
  margin-bottom: 2.2rem;
}

.mcs-features li {
  display: flex;
  align-items: center;
  gap: .65rem;
  font-size: .9rem;
  color: #9aaa9e;
}

.feat-dot {
  width: 7px;
  height: 7px;
  background: #c8a96e;
  border-radius: 50%;
  flex-shrink: 0;
}

.map-mock {
  background: #0d1f14;
  border: 1px solid rgba(200, 169, 110, .18);
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 30px 80px rgba(0, 0, 0, .5);
}

.mm-topbar {
  background: rgba(0, 0, 0, .4);
  padding: .65rem 1rem;
  display: flex;
  align-items: center;
  gap: .4rem;
  border-bottom: 1px solid rgba(200, 169, 110, .1);
}

.mm-dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
}

.mm-topbar span {
  font-size: .62rem;
  color: #6a7a6e;
  margin-left: .4rem;
}

.mm-body {
  position: relative;
  height: 320px;
  background: #0a1a0c;
  overflow: hidden;
}

.mm-bg {
  position: absolute;
  inset: 0;
  background-image: linear-gradient(rgba(200, 169, 110, .03) 1px, transparent 1px), linear-gradient(90deg, rgba(200, 169, 110, .03) 1px, transparent 1px);
  background-size: 30px 30px;
}

.mm-pin {
  position: absolute;
}

.pin-a {
  top: 35%;
  left: 40%;
}

.pin-b {
  top: 55%;
  left: 65%;
}

.pin-c {
  top: 20%;
  left: 70%;
}

.pin-d {
  top: 70%;
  left: 30%;
}

.mmp-dot {
  width: 14px;
  height: 14px;
  border-radius: 50%;
  border: 2px solid rgba(255, 255, 255, .3);
}

.mmp-pulse {
  position: absolute;
  top: -6px;
  left: -6px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 2px solid rgba(26, 71, 42, .4);
  animation: pulse-ring 2s infinite;
}

@keyframes pulse-ring {
  0% {
    transform: scale(1);
    opacity: .8;
  }
  100% {
    transform: scale(2);
    opacity: 0;
  }
}

.mm-cluster {
  position: absolute;
  background: #1a472a;
  color: #c8a96e;
  font-size: .7rem;
  font-weight: 700;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid rgba(200, 169, 110, .3);
}

.mm-cluster.small {
  width: 28px;
  height: 28px;
  font-size: .6rem;
  background: #7b5ea7;
}

.mm-panel {
  position: absolute;
  right: .75rem;
  top: .75rem;
  background: rgba(13, 31, 20, .94);
  border: 1px solid rgba(200, 169, 110, .18);
  border-radius: 8px;
  padding: .5rem .65rem;
  width: 180px;
  backdrop-filter: blur(8px);
  display: flex;
  flex-direction: column;
  gap: .32rem;
}

.mmp-row {
  display: flex;
  align-items: center;
  gap: .4rem;
}

.mmp-dot2 {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  flex-shrink: 0;
}

.mmp-row span {
  font-size: .62rem;
  color: #9aaa9e;
}

/* OBJECTS */
.objects-section, .regions-section {
  position: relative;
  z-index: 2;
  padding: 4rem 2rem;
  max-width: 1400px;
  margin: 0 auto;
}

.sec-head {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  margin-bottom: 2rem;
  gap: 1rem;
  flex-wrap: wrap;
}

.sh-tag {
  display: flex;
  align-items: center;
  gap: .4rem;
  font-size: .65rem;
  color: #c8a96e;
  text-transform: uppercase;
  letter-spacing: .13em;
  margin-bottom: .5rem;
}

.sh-tag svg {
  width: 11px;
  height: 11px;
  fill: none;
}

.sh-title {
  font-family: 'Playfair Display', serif;
  font-size: 1.9rem;
  font-weight: 700;
  color: #f0ebe0;
}

.filter-tabs {
  display: flex;
  gap: .35rem;
  flex-wrap: wrap;
}

.ftab {
  font-family: 'Crimson Pro', serif;
  font-size: .82rem;
  color: #6a7a6e;
  background: rgba(255, 255, 255, .04);
  border: 1px solid rgba(200, 169, 110, .1);
  padding: .38rem .85rem;
  border-radius: 20px;
  cursor: pointer;
  transition: all .2s;
}

.ftab:hover {
  color: #f0ebe0;
  border-color: rgba(200, 169, 110, .28);
}

.ftab.active {
  background: rgba(200, 169, 110, .1);
  color: #c8a96e;
  font-weight: 600;
}

.search-row {
  display: flex;
  gap: .75rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.search-box {
  flex: 1;
  min-width: 220px;
  position: relative;
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, .04);
  border: 1px solid rgba(200, 169, 110, .16);
  border-radius: 9px;
  height: 42px;
  overflow: hidden;
  transition: border-color .2s;
}

.search-box:focus-within {
  border-color: rgba(200, 169, 110, .48);
}

.search-box svg {
  width: 14px;
  height: 14px;
  stroke: #6a7a6e;
  fill: none;
  flex-shrink: 0;
  margin-left: .75rem;
}

.search-box input {
  flex: 1;
  border: none;
  background: transparent;
  color: #f0ebe0;
  font-family: 'Crimson Pro', serif;
  font-size: .95rem;
  padding: 0 .75rem;
  height: 100%;
  outline: none;
}

.search-box input::placeholder {
  color: #3a4e3e;
}

.search-clear {
  width: 26px;
  height: 26px;
  margin-right: .35rem;
  background: rgba(255, 255, 255, .08);
  border: none;
  border-radius: 50%;
  color: #9aaa9e;
  font-size: 1rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}

.region-sel {
  display: flex;
  align-items: center;
  gap: .4rem;
  background: rgba(255, 255, 255, .04);
  border: 1px solid rgba(200, 169, 110, .16);
  border-radius: 9px;
  height: 42px;
  padding: 0 .75rem;
  min-width: 170px;
}

.region-sel svg {
  width: 13px;
  height: 13px;
  stroke: #6a7a6e;
  fill: none;
  flex-shrink: 0;
}

.region-sel select {
  background: transparent;
  border: none;
  color: #f0ebe0;
  font-family: 'Crimson Pro', serif;
  font-size: .9rem;
  outline: none;
  cursor: pointer;
}

.region-sel select option {
  background: #0d1f14;
}

.obj-loading {
  margin-bottom: 2rem;
}

.ld-grid {
  display: grid;
  grid-template-columns:repeat(auto-fill, minmax(280px, 1fr));
  gap: 1.25rem;
}

.ld-card {
  border-radius: 12px;
  overflow: hidden;
  background: rgba(255, 255, 255, .04);
}

.ld-img {
  height: 170px;
}

.ld-body {
  padding: .85rem;
  display: flex;
  flex-direction: column;
  gap: .4rem;
}

.ld-line {
  height: 12px;
  border-radius: 6px;
}

.shimmer {
  background: linear-gradient(90deg, rgba(255, 255, 255, .05) 25%, rgba(255, 255, 255, .09) 50%, rgba(255, 255, 255, .05) 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
}

@keyframes shimmer {
  to {
    background-position: -200% 0;
  }
}

.cards-grid {
  display: grid;
  grid-template-columns:repeat(auto-fill, minmax(290px, 1fr));
  gap: 1.4rem;
}

.obj-card {
  position: relative;
  background: rgba(15, 25, 17, .85);
  border: 1px solid rgba(200, 169, 110, .09);
  border-radius: 13px;
  overflow: hidden;
  cursor: pointer;
  transition: all .3s;
  display: flex;
  flex-direction: column;
  backdrop-filter: blur(4px);
}

.obj-card:hover {
  border-color: rgba(200, 169, 110, .32);
  transform: translateY(-5px);
  box-shadow: 0 20px 50px rgba(0, 0, 0, .4);
}

.oc-ribbon {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 5;
}

.oc-img {
  position: relative;
  height: 185px;
  overflow: hidden;
  cursor: pointer;
}

.oc-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform .4s;
}

.obj-card:hover .oc-img img {
  transform: scale(1.05);
}

.oc-noimg {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.oc-noimg svg {
  width: 44px;
  height: 44px;
}

.oc-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, .55);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: .5rem;
  opacity: 0;
  transition: opacity .3s;
}

.obj-card:hover .oc-overlay {
  opacity: 1;
}

.oc-gallery-hint {
  display: flex;
  align-items: center;
  gap: .35rem;
  font-size: .72rem;
  color: rgba(255, 255, 255, .7);
}

.oc-gallery-hint svg {
  width: 13px;
  height: 13px;
  fill: none;
  stroke: rgba(255, 255, 255, .7);
}

.oc-map-btn {
  display: flex;
  align-items: center;
  gap: .4rem;
  background: rgba(26, 71, 42, .9);
  border: 1px solid rgba(200, 169, 110, .4);
  color: #c8a96e;
  font-family: 'Crimson Pro', serif;
  font-size: .82rem;
  font-weight: 600;
  padding: .5rem 1rem;
  border-radius: 6px;
  cursor: pointer;
}

.oc-map-btn svg {
  width: 13px;
  height: 13px;
  fill: none;
}

.oc-type-badge {
  position: absolute;
  bottom: .5rem;
  left: .5rem;
  font-size: .52rem;
  font-weight: 700;
  text-transform: uppercase;
  color: white;
  padding: .1rem .38rem;
  border-radius: 3px;
}

.oc-photo-count {
  position: absolute;
  top: .45rem;
  right: .45rem;
  display: flex;
  align-items: center;
  gap: .2rem;
  font-size: .55rem;
  font-weight: 700;
  background: rgba(0, 0, 0, .72);
  color: #c8a96e;
  padding: .1rem .38rem;
  border-radius: 3px;
}

.oc-body {
  padding: .9rem 1rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: .4rem;
}

.oc-name {
  font-family: 'Playfair Display', serif;
  font-size: 1rem;
  font-weight: 600;
  color: #f0ebe0;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.oc-loc, .oc-period {
  display: flex;
  align-items: center;
  gap: .3rem;
  font-size: .78rem;
  color: #6a7a6e;
}

.oc-loc svg, .oc-period svg {
  width: 11px;
  height: 11px;
  fill: none;
  flex-shrink: 0;
}

.oc-loc em {
  font-style: normal;
  color: #4a5e4e;
}

.oc-infra {
  display: flex;
  gap: .3rem;
  flex-wrap: wrap;
  margin-top: .15rem;
}

.inf-chip {
  font-size: .62rem;
  padding: .15rem .4rem;
  border-radius: 4px;
}

.inf-yes {
  background: rgba(34, 197, 94, .1);
  color: #86efac;
  border: 1px solid rgba(34, 197, 94, .18);
}

.inf-no {
  background: rgba(239, 68, 68, .07);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, .13);
}

.oc-footer {
  display: flex;
  gap: .4rem;
  margin-top: auto;
  padding-top: .6rem;
  border-top: 1px solid rgba(200, 169, 110, .06);
}

.ocf-btn {
  font-family: 'Crimson Pro', serif;
  font-size: .82rem;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: all .2s;
  display: flex;
  align-items: center;
  gap: .3rem;
}

.ocf-btn svg {
  width: 12px;
  height: 12px;
  fill: none;
}

.ocf-detail {
  flex: 1;
  padding: .5rem .75rem;
  background: rgba(200, 169, 110, .09);
  color: #c8a96e;
  border: 1px solid rgba(200, 169, 110, .18);
  justify-content: space-between;
  font-weight: 500;
}

.ocf-detail:hover {
  background: rgba(200, 169, 110, .18);
}

.ocf-gallery {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  background: rgba(200, 169, 110, .08);
  color: #c8a96e;
  border: 1px solid rgba(200, 169, 110, .18);
  justify-content: center;
}

.ocf-gallery:hover {
  background: rgba(200, 169, 110, .2);
}

.ocf-map {
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  background: rgba(26, 71, 42, .45);
  color: #c8a96e;
  border: 1px solid rgba(200, 169, 110, .18);
  justify-content: center;
}

.ocf-map:hover {
  background: rgba(26, 71, 42, .85);
}

.empty-state {
  text-align: center;
  padding: 3rem;
  color: #6a7a6e;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
}

.es-icon {
  width: 64px;
  height: 64px;
  background: rgba(255, 255, 255, .04);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.es-icon svg {
  width: 30px;
  height: 30px;
  stroke: #6a7a6e;
  fill: none;
}

.pagination {
  display: flex;
  justify-content: center;
  gap: .3rem;
  margin-top: 2.5rem;
  flex-wrap: wrap;
}

.pg-btn {
  width: 36px;
  height: 36px;
  background: rgba(255, 255, 255, .04);
  border: 1px solid rgba(200, 169, 110, .1);
  border-radius: 6px;
  color: #9aaa9e;
  font-family: 'Crimson Pro', serif;
  font-size: .9rem;
  cursor: pointer;
  transition: all .2s;
}

.pg-btn:hover:not(:disabled):not(.dots) {
  background: rgba(200, 169, 110, .1);
  color: #c8a96e;
}

.pg-btn.active {
  background: rgba(26, 71, 42, .8);
  border-color: rgba(200, 169, 110, .4);
  color: #c8a96e;
  font-weight: 700;
}

.pg-btn:disabled {
  opacity: .3;
  cursor: not-allowed;
}

.pg-btn.dots {
  border: none;
  background: none;
  cursor: default;
}

.view-all-wrap {
  display: flex;
  justify-content: center;
  margin-top: 2.5rem;
}

.view-all-btn {
  display: inline-flex;
  align-items: center;
  gap: .6rem;
  font-family: 'Crimson Pro', serif;
  font-size: 1rem;
  font-weight: 500;
  color: #c8a96e;
  text-decoration: none;
  border: 1px solid rgba(200, 169, 110, .22);
  padding: .85rem 2.2rem;
  border-radius: 8px;
  background: rgba(200, 169, 110, .05);
  transition: all .25s;
}

.view-all-btn svg {
  width: 14px;
  height: 14px;
  fill: none;
}

.view-all-btn:hover {
  background: rgba(200, 169, 110, .11);
  border-color: rgba(200, 169, 110, .42);
}

/* REGIONS */
.regions-section {
  border-top: 1px solid rgba(200, 169, 110, .07);
}

.regions-grid {
  display: grid;
  grid-template-columns:repeat(auto-fill, minmax(200px, 1fr));
  gap: .6rem;
}

.region-card {
  position: relative;
  overflow: hidden;
  background: rgba(15, 25, 17, .75);
  border: 1px solid rgba(200, 169, 110, .09);
  border-radius: 9px;
  padding: .85rem 1rem;
  cursor: pointer;
  transition: all .25s;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.region-card:hover {
  border-color: rgba(200, 169, 110, .32);
  transform: translateX(3px);
}

.rc-bar {
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  opacity: .06;
}

.rc-content {
  display: flex;
  flex-direction: column;
  gap: .18rem;
  z-index: 1;
}

.rc-name {
  font-size: .82rem;
  color: #f0ebe0;
  font-weight: 500;
}

.rc-count {
  font-family: 'Playfair Display', serif;
  font-size: 1.2rem;
  font-weight: 700;
  color: #c8a96e;
}

.rc-arrow svg {
  width: 14px;
  height: 14px;
  stroke: #6a7a6e;
  fill: none;
  z-index: 1;
  transition: transform .2s;
}

.region-card:hover .rc-arrow svg {
  transform: translateX(3px);
  stroke: #c8a96e;
}

/* MODALS */
.modal-ov {
  position: fixed;
  inset: 0;
  z-index: 9000;
  background: rgba(0, 0, 0, .82);
  backdrop-filter: blur(10px);
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
}

.modal-box {
  background: #0f1c12;
  border: 1px solid rgba(200, 169, 110, .18);
  border-radius: 16px;
  width: 100%;
  max-width: 700px;
  max-height: 90vh;
  overflow-y: auto;
  position: relative;
  box-shadow: 0 32px 80px rgba(0, 0, 0, .65);
}

.modal-x {
  position: absolute;
  top: .8rem;
  right: .8rem;
  z-index: 10;
  width: 30px;
  height: 30px;
  background: rgba(0, 0, 0, .55);
  border: none;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.modal-x:hover {
  background: rgba(0, 0, 0, .85);
}

.modal-x svg {
  width: 13px;
  height: 13px;
  stroke: white;
  fill: none;
}

.d-hero {
  height: 220px;
  position: relative;
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}

.d-hero img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.d-hero-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, .88) 0%, transparent 55%);
}

.d-hero-gallery-hint {
  position: absolute;
  top: .75rem;
  left: .75rem;
  display: flex;
  align-items: center;
  gap: .3rem;
  font-size: .65rem;
  color: rgba(255, 255, 255, .8);
  background: rgba(0, 0, 0, .55);
  padding: .2rem .55rem;
  border-radius: 4px;
  border: 1px solid rgba(255, 255, 255, .15);
}

.d-hero-gallery-hint svg {
  width: 11px;
  height: 11px;
  stroke: rgba(255, 255, 255, .8);
  fill: none;
}

.d-hero-txt {
  position: absolute;
  bottom: 1rem;
  left: 1.2rem;
  right: 1.2rem;
}

.d-tag {
  display: inline-block;
  font-size: .54rem;
  font-weight: 700;
  text-transform: uppercase;
  color: white;
  padding: .12rem .4rem;
  border-radius: 3px;
  margin-bottom: .3rem;
}

.d-hero-txt h2 {
  font-family: 'Playfair Display', serif;
  font-size: 1.3rem;
  font-weight: 700;
  color: white;
  line-height: 1.2;
  text-shadow: 0 2px 8px rgba(0, 0, 0, .5);
}

.d-body {
  padding: 1rem 1.2rem;
}

.info-grid {
  display: grid;
  grid-template-columns:repeat(auto-fill, minmax(150px, 1fr));
  gap: .6rem;
}

.ig-item {
  display: flex;
  flex-direction: column;
  gap: .1rem;
}

.ig-item span {
  font-size: .58rem;
  color: #6a7a6e;
  text-transform: uppercase;
  letter-spacing: .06em;
}

.ig-item strong {
  font-size: .85rem;
  color: #f0ebe0;
  font-weight: 500;
}

.d-photo-strip {
  display: flex;
  gap: .35rem;
  padding: .5rem 1.2rem;
  overflow-x: auto;
  background: rgba(0, 0, 0, .3);
  border-top: 1px solid rgba(200, 169, 110, .07);
  scrollbar-width: thin;
}

.dps-thumb {
  width: 58px;
  height: 44px;
  border-radius: 5px;
  overflow: hidden;
  flex-shrink: 0;
  cursor: pointer;
  transition: transform .2s;
  border: 1.5px solid rgba(200, 169, 110, .1);
}

.dps-thumb:hover {
  transform: scale(1.06);
  border-color: rgba(200, 169, 110, .4);
}

.dps-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.dps-more {
  width: 58px;
  height: 44px;
  border-radius: 5px;
  flex-shrink: 0;
  cursor: pointer;
  background: rgba(200, 169, 110, .1);
  border: 1.5px solid rgba(200, 169, 110, .2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: .7rem;
  color: #c8a96e;
  font-weight: 700;
}

.d-footer {
  padding: .75rem 1.2rem;
  border-top: 1px solid rgba(200, 169, 110, .1);
  display: flex;
  gap: .5rem;
  justify-content: flex-end;
}

.dfbtn {
  display: inline-flex;
  align-items: center;
  gap: .4rem;
  font-family: 'Crimson Pro', serif;
  font-size: .88rem;
  font-weight: 600;
  padding: .55rem 1.1rem;
  border-radius: 7px;
  cursor: pointer;
  border: none;
  transition: all .2s;
  text-decoration: none;
}

.dfbtn svg {
  width: 13px;
  height: 13px;
  fill: none;
}

.dfbtn-map {
  background: linear-gradient(135deg, #1a472a, #2a6a40);
  color: #c8a96e;
  border: 1px solid rgba(200, 169, 110, .3);
}

.dfbtn-map:hover {
  background: linear-gradient(135deg, #2a6a40, #3a8a55);
}

.dfbtn-sec {
  background: rgba(255, 255, 255, .06);
  color: #9aaa9e;
  border: 1px solid rgba(200, 169, 110, .1);
}

.dfbtn-sec:hover {
  background: rgba(255, 255, 255, .1);
}

.modal-fade-enter-active, .modal-fade-leave-active {
  transition: opacity .22s;
}

.modal-fade-enter, .modal-fade-leave-to {
  opacity: 0;
}

/* ARTIFACTS */
.artifacts-section {
  position: relative;
  z-index: 2;
  background: rgba(200, 129, 58, .025);
  border-top: 1px solid rgba(200, 129, 58, .1);
  padding: 4rem 0;
}

.art-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

.art-meta {
  display: flex;
  align-items: center;
}

.art-total-badge {
  font-family: 'Playfair Display', serif;
  font-size: .82rem;
  font-weight: 700;
  color: #c8813a;
  background: rgba(200, 129, 58, .1);
  border: 1px solid rgba(200, 129, 58, .22);
  padding: .35rem .9rem;
  border-radius: 20px;
}

.art-filter-row {
  display: flex;
  gap: .75rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.art-ld-grid {
  display: grid;
  grid-template-columns:repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
}

.art-ld-card {
  border-radius: 10px;
  overflow: hidden;
  background: rgba(255, 255, 255, .04);
}

.art-ld-img {
  height: 140px;
}

.art-grid {
  display: grid;
  grid-template-columns:repeat(auto-fill, minmax(220px, 1fr));
  gap: 1.2rem;
}

.art-card {
  background: rgba(18, 12, 5, .88);
  border: 1px solid rgba(200, 129, 58, .13);
  border-radius: 11px;
  overflow: hidden;
  cursor: pointer;
  transition: all .3s;
  display: flex;
  flex-direction: column;
}

.art-card:hover {
  border-color: rgba(200, 129, 58, .42);
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(200, 129, 58, .13);
}

.art-card-img {
  position: relative;
  height: 160px;
  overflow: hidden;
  cursor: pointer;
}

.art-card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform .4s;
}

.art-card:hover .art-card-img img {
  transform: scale(1.06);
}

.art-noimg {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(200, 129, 58, .04);
}

.art-noimg svg {
  width: 40px;
  height: 40px;
}

.art-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, .55);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity .3s;
}

.art-card:hover .art-overlay {
  opacity: 1;
}

.art-overlay svg {
  width: 28px;
  height: 28px;
}

.art-holat {
  position: absolute;
  top: .45rem;
  left: .45rem;
  font-size: .56rem;
  font-weight: 700;
  padding: .12rem .42rem;
  border-radius: 4px;
}

.holat-yax {
  background: rgba(34, 197, 94, .18);
  color: #86efac;
  border: 1px solid rgba(34, 197, 94, .28);
}

.holat-kem {
  background: rgba(245, 158, 11, .12);
  color: #fcd34d;
  border: 1px solid rgba(245, 158, 11, .22);
}

.art-inv {
  position: absolute;
  bottom: .45rem;
  right: .45rem;
  font-size: .56rem;
  font-weight: 600;
  background: rgba(0, 0, 0, .78);
  color: #c8813a;
  padding: .1rem .38rem;
  border-radius: 3px;
}

.art-photo-count {
  position: absolute;
  top: .45rem;
  right: .45rem;
  display: flex;
  align-items: center;
  gap: .2rem;
  font-size: .55rem;
  font-weight: 700;
  background: rgba(0, 0, 0, .72);
  color: #c8813a;
  padding: .1rem .35rem;
  border-radius: 3px;
}

.art-body {
  padding: .75rem .9rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: .35rem;
}

.art-name {
  font-family: 'Playfair Display', serif;
  font-size: .92rem;
  font-weight: 600;
  color: #f0ebe0;
  line-height: 1.3;
}

.art-meta-row {
  display: flex;
  align-items: center;
  gap: .5rem;
  flex-wrap: wrap;
}

.art-davr {
  display: flex;
  align-items: center;
  gap: .25rem;
  font-size: .7rem;
  color: #c8813a;
}

.art-davr svg {
  width: 10px;
  height: 10px;
  fill: none;
}

.art-mat {
  font-size: .6rem;
  background: rgba(200, 129, 58, .1);
  color: #c8813a;
  border: 1px solid rgba(200, 129, 58, .18);
  padding: .08rem .35rem;
  border-radius: 3px;
}

.art-loc {
  display: flex;
  align-items: center;
  gap: .28rem;
  font-size: .7rem;
  color: #6a7a6e;
}

.art-loc svg {
  width: 10px;
  height: 10px;
  fill: none;
  flex-shrink: 0;
}

.art-footer {
  margin-top: auto;
  padding-top: .5rem;
  border-top: 1px solid rgba(200, 129, 58, .07);
}

.art-actions {
  display: flex;
  gap: .3rem;
}

.art-btn {
  font-family: 'Crimson Pro', serif;
  font-size: .75rem;
  font-weight: 600;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  transition: all .2s;
  display: flex;
  align-items: center;
  gap: .25rem;
  text-decoration: none;
}

.art-btn svg {
  width: 11px;
  height: 11px;
  fill: none;
}

.art-btn-pdf {
  padding: .38rem .65rem;
  background: rgba(239, 68, 68, .1);
  color: #fca5a5;
  border: 1px solid rgba(239, 68, 68, .18);
}

.art-btn-pdf:hover {
  background: rgba(239, 68, 68, .2);
}

.art-btn-detail {
  flex: 1;
  padding: .38rem .65rem;
  background: rgba(200, 129, 58, .1);
  color: #c8813a;
  border: 1px solid rgba(200, 129, 58, .2);
  justify-content: space-between;
}

.art-btn-detail:hover {
  background: rgba(200, 129, 58, .22);
}

.art-modal-box {
  max-width: 780px;
}

.amd-gallery {
  border-radius: 16px 16px 0 0;
  overflow: hidden;
}

.amd-main-photo {
  position: relative;
  height: 260px;
  background: rgba(30, 20, 8, .9);
}

.amd-main-photo img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.amd-nophoto {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.amd-nophoto svg {
  width: 60px;
  height: 60px;
}

.amd-photo-overlay {
  position: absolute;
  inset: 0;
  background: linear-gradient(to top, rgba(0, 0, 0, .88) 0%, transparent 50%);
}

.amd-title-overlay {
  position: absolute;
  bottom: 1rem;
  left: 1.2rem;
  right: 1.2rem;
}

.amd-inv-badge {
  display: inline-block;
  font-size: .58rem;
  font-weight: 700;
  background: rgba(200, 129, 58, .28);
  color: #c8813a;
  border: 1px solid rgba(200, 129, 58, .38);
  padding: .12rem .5rem;
  border-radius: 4px;
  margin-bottom: .35rem;
}

.amd-title-overlay h2 {
  font-family: 'Playfair Display', serif;
  font-size: 1.4rem;
  font-weight: 700;
  color: white;
  line-height: 1.2;
  text-shadow: 0 2px 8px rgba(0, 0, 0, .5);
}

.amd-davr {
  font-size: .75rem;
  color: rgba(200, 129, 58, .9);
  margin-top: .2rem;
  display: block;
}

.amd-thumbs {
  display: flex;
  gap: .3rem;
  padding: .5rem 1.2rem;
  overflow-x: auto;
  background: rgba(0, 0, 0, .3);
  border-bottom: 1px solid rgba(200, 129, 58, .1);
}

.amd-thumb {
  width: 58px;
  height: 44px;
  border-radius: 5px;
  overflow: hidden;
  cursor: pointer;
  flex-shrink: 0;
  transition: transform .2s;
  border: 1.5px solid rgba(200, 129, 58, .13);
}

.amd-thumb:hover, .amd-thumb.active {
  transform: scale(1.06);
  border-color: #c8813a;
}

.amd-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.amd-body {
  padding: 1rem 1.2rem;
  display: flex;
  flex-direction: column;
  gap: .85rem;
}

.amd-section {
  background: rgba(255, 255, 255, .03);
  border: 1px solid rgba(200, 129, 58, .09);
  border-radius: 9px;
  padding: .8rem .95rem;
}

.amd-sec-title {
  display: flex;
  align-items: center;
  gap: .38rem;
  font-size: .6rem;
  font-weight: 700;
  text-transform: uppercase;
  color: #c8813a;
  margin-bottom: .65rem;
}

.amd-sec-title svg {
  width: 12px;
  height: 12px;
  fill: none;
}

.yes-txt {
  color: #86efac !important;
}

.warn-txt {
  color: #fcd34d !important;
}

/* MUSEUM CATALOG */
.museum-catalog-section {
  position: relative;
  z-index: 2;
  background: rgba(46, 134, 171, .02);
  border-top: 1px solid rgba(46, 134, 171, .12);
  padding: 4rem 0;
}

.mc-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
}

.mc-filter-row {
  display: flex;
  gap: .75rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.cat-loading {
  margin-bottom: 2rem;
}

.cat-ld-grid {
  display: grid;
  grid-template-columns:repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
}

.cat-ld-row {
  border-radius: 10px;
  overflow: hidden;
  background: rgba(255, 255, 255, .04);
  display: flex;
  height: 90px;
}

.cld-img {
  width: 90px;
  flex-shrink: 0;
}

.cld-body {
  flex: 1;
  padding: .85rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: .4rem;
}

.cat-grid {
  display: grid;
  grid-template-columns:repeat(auto-fill, minmax(260px, 1fr));
  gap: 1.25rem;
}

.cat-card {
  background: rgba(10, 18, 28, .88);
  border: 1px solid rgba(46, 134, 171, .13);
  border-radius: 13px;
  overflow: hidden;
  cursor: pointer;
  transition: all .3s;
  display: flex;
  flex-direction: column;
}

.cat-card:hover {
  border-color: rgba(46, 134, 171, .45);
  transform: translateY(-4px);
  box-shadow: 0 16px 40px rgba(46, 134, 171, .12);
}

.cat-img-wrap {
  position: relative;
  height: 175px;
  overflow: hidden;
  cursor: pointer;
}

.cat-img-wrap img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform .4s;
}

.cat-card:hover .cat-img-wrap img {
  transform: scale(1.05);
}

.cat-noimg {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(46, 134, 171, .04);
}

.cat-noimg svg {
  width: 42px;
  height: 42px;
}

.cat-count-badge {
  position: absolute;
  top: .5rem;
  right: .5rem;
  font-size: .58rem;
  font-weight: 700;
  background: rgba(0, 0, 0, .78);
  color: #5bc0e8;
  padding: .12rem .42rem;
  border-radius: 4px;
  border: 1px solid rgba(46, 134, 171, .3);
}

.cat-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, .55);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity .3s;
}

.cat-card:hover .cat-overlay {
  opacity: 1;
}

.cat-photo-count {
  position: absolute;
  bottom: .45rem;
  right: .45rem;
  display: flex;
  align-items: center;
  gap: .2rem;
  font-size: .55rem;
  font-weight: 700;
  background: rgba(0, 0, 0, .72);
  color: #5bc0e8;
  padding: .1rem .35rem;
  border-radius: 3px;
}

.cat-body {
  padding: .85rem .95rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: .35rem;
}

.cat-kp {
  font-size: .56rem;
  color: rgba(91, 192, 232, .6);
  font-weight: 600;
}

.cat-title {
  font-family: 'Playfair Display', serif;
  font-size: .92rem;
  font-weight: 600;
  color: #e8e8f0;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.cat-meta {
  display: flex;
  align-items: center;
  gap: .4rem;
  flex-wrap: wrap;
}

.cat-chip {
  font-size: .6rem;
  padding: .1rem .35rem;
  border-radius: 4px;
}

.cat-chip-date {
  background: rgba(46, 134, 171, .1);
  color: #5bc0e8;
  border: 1px solid rgba(46, 134, 171, .2);
  display: flex;
  align-items: center;
  gap: .2rem;
}

.cat-chip-mat {
  background: rgba(200, 169, 110, .08);
  color: #c8a96e;
  border: 1px solid rgba(200, 169, 110, .16);
}

.cat-museum {
  display: flex;
  align-items: flex-start;
  gap: .28rem;
  font-size: .68rem;
  color: #5a6a7e;
  line-height: 1.35;
}

.cat-production {
  display: flex;
  align-items: center;
  gap: .28rem;
  font-size: .68rem;
  color: #5a6a7e;
}

.cat-footer {
  margin-top: auto;
  padding-top: .5rem;
  border-top: 1px solid rgba(46, 134, 171, .07);
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.cat-storage {
  font-size: .62rem;
  color: #4a5a6e;
  font-style: italic;
}

.cat-detail-btn {
  display: flex;
  align-items: center;
  gap: .25rem;
  font-family: 'Crimson Pro', serif;
  font-size: .75rem;
  font-weight: 600;
  background: rgba(46, 134, 171, .12);
  color: #5bc0e8;
  border: 1px solid rgba(46, 134, 171, .22);
  padding: .35rem .65rem;
  border-radius: 5px;
  cursor: pointer;
  transition: all .2s;
}

.cat-detail-btn:hover {
  background: rgba(46, 134, 171, .25);
}

.cat-modal-box {
  max-width: 780px;
}

/* BUTTONS */
.btn-primary {
  display: inline-flex;
  align-items: center;
  gap: .5rem;
  background: linear-gradient(135deg, #1a472a, #2a6a40);
  color: #c8a96e;
  font-family: 'Crimson Pro', serif;
  font-size: 1rem;
  font-weight: 600;
  padding: .85rem 1.8rem;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid rgba(200, 169, 110, .3);
  transition: all .25s;
}

.btn-primary svg {
  width: 16px;
  height: 16px;
  fill: none;
}

.btn-primary:hover {
  background: linear-gradient(135deg, #2a6a40, #3a8a55);
  transform: translateY(-2px);
  box-shadow: 0 10px 35px rgba(26, 71, 42, .55);
}

.btn-primary.btn-large {
  font-size: 1.08rem;
  padding: 1rem 2.2rem;
}

.btn-secondary {
  display: inline-flex;
  align-items: center;
  gap: .5rem;
  background: rgba(255, 255, 255, .05);
  color: #f0ebe0;
  font-family: 'Crimson Pro', serif;
  font-size: 1rem;
  font-weight: 500;
  padding: .85rem 1.8rem;
  border-radius: 8px;
  text-decoration: none;
  cursor: pointer;
  border: 1px solid rgba(200, 169, 110, .18);
  transition: all .25s;
}

.btn-secondary:hover {
  background: rgba(200, 169, 110, .09);
  border-color: rgba(200, 169, 110, .38);
}

/* ══════════ CULTURAL WEALTH ══════════ */
.cw-pub-section {
  position: relative;
  z-index: 2;
  background: rgba(8, 20, 12, .6);
  border-top: 1px solid rgba(79, 142, 247, .15);
  padding: 4rem 0;
}

.cw-pub-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: radial-gradient(ellipse at 30% 60%, rgba(79, 142, 247, .06), transparent 55%), radial-gradient(ellipse at 80% 20%, rgba(167, 139, 250, .05), transparent 50%);
  pointer-events: none;
}

.cw-pub-inner {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 2rem;
  position: relative;
}

.cw-pub-stats-row {
  display: flex;
  flex-wrap: wrap;
  gap: .4rem;
  justify-content: flex-end;
}

.cw-pub-stat-pill {
  display: flex;
  align-items: center;
  gap: .35rem;
  background: rgba(255, 255, 255, .04);
  border: 1px solid rgba(255, 255, 255, .07);
  border-radius: 20px;
  padding: .25rem .65rem;
}

.cw-pub-stat-dot {
  width: 6px;
  height: 6px;
  border-radius: 50%;
  flex-shrink: 0;
}

.cw-pub-stat-label {
  font-size: .58rem;
  color: #6a7a6e;
  text-transform: uppercase;
  letter-spacing: .06em;
}

.cw-pub-stat-num {
  font-family: 'Playfair Display', serif;
  font-size: .78rem;
  font-weight: 700;
}

.cw-pub-tabs-wrap {
  overflow-x: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  margin-bottom: 1.75rem;
}

.cw-pub-tabs-wrap::-webkit-scrollbar {
  display: none;
}

.cw-pub-tabs {
  display: flex;
  gap: .4rem;
  padding: .5rem;
  background: rgba(255, 255, 255, .025);
  border: 1px solid rgba(255, 255, 255, .06);
  border-radius: 13px;
  width: max-content;
  min-width: 100%;
}

.cw-pub-tab {
  display: flex;
  align-items: center;
  gap: .5rem;
  padding: .55rem 1.1rem;
  border-radius: 9px;
  border: 1.5px solid transparent;
  background: transparent;
  font-family: 'Crimson Pro', serif;
  font-size: .88rem;
  color: #6a7a6e;
  cursor: pointer;
  transition: all .2s;
  white-space: nowrap;
}

.cw-pub-tab:hover {
  background: rgba(255, 255, 255, .04);
  color: #9aaa9e;
}

.cw-pub-tab.active {
  background: rgba(255, 255, 255, .06);
}

.cw-pub-tab-cnt {
  font-size: .62rem;
  font-weight: 700;
  padding: .1rem .42rem;
  border-radius: 10px;
  background: rgba(255, 255, 255, .06);
  color: #6a7a6e;
}

.cw-pub-filter-row {
  display: flex;
  gap: .75rem;
  margin-bottom: 2rem;
  flex-wrap: wrap;
  align-items: center;
}

.cw-pub-reset-btn {
  width: 42px;
  height: 42px;
  background: rgba(255, 255, 255, .04);
  border: 1px solid rgba(200, 169, 110, .16);
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all .2s;
  flex-shrink: 0;
}

.cw-pub-reset-btn:hover {
  background: rgba(239, 68, 68, .08);
  border-color: rgba(239, 68, 68, .3);
}

.cw-pub-reset-btn svg {
  width: 14px;
  height: 14px;
  stroke: #9aaa9e;
  fill: none;
}

.cw-pub-ld-grid {
  display: grid;
  grid-template-columns:repeat(auto-fill, minmax(240px, 1fr));
  gap: 1.2rem;
}

.cw-pub-ld-card {
  border-radius: 11px;
  overflow: hidden;
  background: rgba(255, 255, 255, .04);
}

.cw-pub-grid {
  display: grid;
  grid-template-columns:repeat(auto-fill, minmax(260px, 1fr));
  gap: 1.4rem;
}

.cw-pub-card {
  position: relative;
  display: flex;
  flex-direction: column;
  background: rgba(10, 18, 14, .88);
  border: 1px solid rgba(255, 255, 255, .07);
  border-radius: 13px;
  overflow: hidden;
  cursor: pointer;
  transition: all .3s;
  backdrop-filter: blur(4px);
}

.cw-pub-card:hover {
  border-color: color-mix(in srgb, var(--tab-color) 45%, transparent);
  transform: translateY(-5px);
  box-shadow: 0 18px 45px rgba(0, 0, 0, .4);
}

.cw-pub-card-ribbon {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  z-index: 5;
}

.cw-pub-card-img {
  position: relative;
  height: 170px;
  overflow: hidden;
}

.cw-pub-card-img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
  transition: transform .4s;
}

.cw-pub-card:hover .cw-pub-card-img img {
  transform: scale(1.05);
}

.cw-pub-card-noimg {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.cw-pub-card-overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, .5);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity .3s;
}

.cw-pub-card:hover .cw-pub-card-overlay {
  opacity: 1;
}

.cw-pub-card-type-badge {
  position: absolute;
  bottom: .5rem;
  left: .5rem;
  font-size: .52rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .07em;
  color: white;
  padding: .1rem .38rem;
  border-radius: 3px;
}

.cw-pub-card-inv {
  position: absolute;
  top: .45rem;
  right: .45rem;
  font-size: .55rem;
  font-weight: 600;
  background: rgba(0, 0, 0, .75);
  color: #c8a96e;
  padding: .1rem .38rem;
  border-radius: 3px;
  max-width: 100px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cw-pub-card-body {
  padding: .85rem 1rem;
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: .4rem;
}

.cw-pub-card-name {
  font-family: 'Playfair Display', serif;
  font-size: .95rem;
  font-weight: 600;
  color: #f0ebe0;
  line-height: 1.3;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.cw-pub-card-meta {
  display: flex;
  flex-direction: column;
  gap: .22rem;
}

.cw-pub-meta-item {
  display: flex;
  align-items: center;
  gap: .28rem;
  font-size: .72rem;
  color: #6a7a6e;
  line-height: 1.4;
}

.cw-pub-card-chips {
  display: flex;
  flex-wrap: wrap;
  gap: .25rem;
  margin-top: .15rem;
}

.cw-pub-chip {
  font-size: .6rem;
  background: rgba(255, 255, 255, .05);
  border: 1px solid rgba(255, 255, 255, .09);
  color: #9aaa9e;
  padding: .1rem .38rem;
  border-radius: 4px;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.cw-pub-card-footer {
  margin-top: auto;
  padding-top: .55rem;
  border-top: 1px solid rgba(255, 255, 255, .05);
}

.cw-pub-detail-btn {
  display: inline-flex;
  align-items: center;
  gap: .3rem;
  font-family: 'Crimson Pro', serif;
  font-size: .78rem;
  font-weight: 600;
  padding: .4rem .8rem;
  border-radius: 6px;
  border: 1px solid transparent;
  cursor: pointer;
  transition: all .2s;
}

.cw-pub-detail-btn:hover {
  filter: brightness(1.2);
}

.cw-detail-modal-box {
  max-width: 720px;
}

.cw-modal-section {
  margin-bottom: .85rem;
}

.cw-modal-sec-title {
  display: flex;
  align-items: center;
  gap: .38rem;
  font-size: .58rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: .09em;
  color: #c8a96e;
  margin-bottom: .6rem;
  padding-bottom: .4rem;
  border-bottom: 1px solid rgba(200, 169, 110, .1);
}

.cw-modal-annotation {
  font-size: .88rem;
  color: #9aaa9e;
  line-height: 1.7;
  background: rgba(255, 255, 255, .03);
  padding: .85rem 1rem;
  border-radius: 8px;
  border: 1px solid rgba(255, 255, 255, .06);
}

/* FOOTER */
.site-footer {
  position: relative;
  z-index: 2;
  background: rgba(0, 0, 0, .45);
  border-top: 1px solid rgba(200, 169, 110, .1);
  padding: 2rem;
}

.footer-inner {
  max-width: 1400px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 1.5rem;
  flex-wrap: wrap;
}

.footer-brand {
  display: flex;
  align-items: center;
  gap: .75rem;
}

.footer-brand-name {
  font-family: 'Playfair Display', serif;
  color: #c8a96e;
  font-size: .88rem;
  font-weight: 700;
}

.footer-brand-sub {
  font-size: .62rem;
  color: #5a6a5e;
  margin-top: .12rem;
}

.footer-links {
  display: flex;
  gap: 1.5rem;
}

.fl-link {
  font-family: 'Crimson Pro', serif;
  font-size: .85rem;
  color: #6a7a6e;
  text-decoration: none;
  transition: color .2s;
}

.fl-link:hover {
  color: #c8a96e;
}

.footer-copy {
  font-size: .7rem;
  color: #3a4e3e;
}

/* RESPONSIVE */
@media (max-width: 1024px) {
  .mcs-inner {
    grid-template-columns:1fr;
  }

  .mcs-preview {
    display: none;
  }

  .hero-right {
    display: none;
  }

  .hero-left {
    max-width: 100%;
  }

  .stats-inner {
    grid-template-columns:repeat(2, 1fr);
  }

  .hsb-item:last-of-type {
    display: none;
  }

  .cw-pub-stats-row {
    display: none;
  }
}

@media (max-width: 700px) {
  .main-nav {
    display: none;
  }

  .mobile-menu-btn {
    display: flex;
  }

  .hero-track {
    min-height: 88vh;
  }

  .hero-stage {
    padding: 0 1.25rem;
    padding-bottom: 90px;
  }

  .ht-big {
    font-size: clamp(3rem, 12vw, 5rem);
  }

  .stats-inner {
    grid-template-columns:1fr 1fr;
  }

  .stat-card {
    padding: 1.2rem 1rem;
  }

  .objects-section, .regions-section, .map-cta-section {
    padding: 2.5rem 1.25rem;
  }

  .sec-head {
    flex-direction: column;
    align-items: flex-start;
  }

  .cards-grid {
    grid-template-columns:1fr;
  }

  .footer-inner {
    flex-direction: column;
    text-align: center;
  }

  .footer-links {
    justify-content: center;
  }

  .stat-card::after {
    display: none;
  }

  .header-inner {
    padding: 0 1rem;
  }

  .art-grid {
    grid-template-columns:repeat(2, 1fr);
    gap: .75rem;
  }

  .art-filter-row, .mc-filter-row {
    flex-direction: column;
  }

  .cat-grid {
    grid-template-columns:1fr;
  }

  .hero-stats-bar {
    height: auto;
    flex-wrap: wrap;
    padding: .5rem 0;
  }

  .hsb-item {
    padding: .4rem 1.2rem;
    min-width: auto;
    border-right: none;
  }

  .slider-controls-inline {
    padding: .4rem 1.2rem;
    border-left: none;
    border-top: 1px solid rgba(200, 169, 110, .07);
    width: 100%;
    justify-content: center;
  }

  .hero-progress-line {
    bottom: auto;
    top: 0;
  }

  .amd-main-photo {
    height: 200px;
  }

  .mc-inner {
    padding: 0 1.25rem;
  }

  .art-inner {
    padding: 0 1.25rem;
  }

  .lb-prev {
    left: .5rem;
  }

  .lb-next {
    right: .5rem;
  }

  .lb-photo {
    max-height: 60vh;
  }

  .cw-pub-inner {
    padding: 0 1.25rem;
  }

  .cw-pub-grid {
    grid-template-columns:1fr 1fr;
    gap: .85rem;
  }

  .cw-pub-filter-row {
    flex-direction: column;
  }
}

@media (max-width: 420px) {
  .art-grid {
    grid-template-columns:1fr;
  }

  .cw-pub-grid {
    grid-template-columns:1fr;
  }
}
</style>